import { Component, OnInit, AfterViewInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ToasterService } from 'angular2-toaster';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../store';
import * as fromRootStore from '../../reducers';
import { clientHistoryComponent } from '../common/clientHistory';
import { trackHistoryComponent } from '../common/trackHistory';
import { ReportsService, CommonService, OctTypeService } from '../../services/index';
import { EmployeeModel } from '../../model/index';
import { dataComparisonComponent } from '../common/dataComparison.component';
import swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
    selector: 'reports-tab',
    templateUrl: './reports.component.html'
})
export class ReportsComponent implements OnInit, AfterViewInit {
    private searchTermsEmp = new Subject<string>();
    typeview = [];
    Serviceview: string[];
    warranty = [];
    showServiceView: boolean;
    typeList: string[];
    @Input('tabTitle') title: string;
    @Input('tabID') tabID: string;
    @Input('params') params: string;
    @Input() active = false;
    @Input() dataContext;
    @ViewChild('filterPanel') filterPanel;
    branchCtrl: FormControl;
    stateCtrl: FormControl;
    districtCtrl: FormControl;
    userCtrl: FormControl;
    filteredBranch: Observable<any[]>;
    statusCtrl: FormControl;
    filteredStatus: Observable<any[]>;
    filteredEmp: Observable<any[]>;
    testStatusCtrl: FormControl;
    filteredTestStatus: Observable<any[]>;
    filteredState: Observable<any[]>;
    filteredDistrict: Observable<any[]>;
    filteredUser: Observable<any[]>;
    //@ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    isLoadMask: Promise<any>;
    loadingIndicator: boolean = true;
    filterData = {
        "from_date": new Date(),
        "to_date": new Date(),
        "entry_from_date": null,
        "entry_to_date": null,
        "view_type": '',
        //"followup_id": '',
        //"group_by": 'Client'
    };
    clientdata: any;
    scrollTimeout: any;
    suppressPaging: boolean = false;
    viewTypeCtrl: FormControl;
    //warrantyTypeCtrl: FormControl;
    hvTypeCtrl: FormControl;
    referenceCtrl: FormControl;
    //groupByCtrl: FormControl;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    reportData = [];
    columns = [];
    toggleCol = [];

    // Dynamic column selection for srfPendingReport
    allAvailableColumns = [];
    selectedColumns = [];
    selectedColumnProps = [];
    showColumnFilter = false;
    viewTypeList = [];
    userListMap: any = {}; // Maps fullname to userid for notification report
    isNotificationFilterDisabled = false; // Disable filter for non-admin users

    // Dynamic Column Filter Properties - works for ALL reports
    columnFilters: any = {};
    showDropdown: any = {};
    dropdownOptions: any = {};
    filteredOptions: any = {};

    hideDropdownTimeout: any;

    // Single dropdown management
    currentActiveFilter: string = '';
    currentFilterSearch: string = '';
    currentSelectAllState: boolean = true;
    currentFilteredOptions: string[] = [];
    currentSelectedOptions: any = {};

    hvTypeList = [];
    branchList: any[] = [];
    itemList: any[] = [];
    statusList: any[] = [];
    testStatusList: any[] = [];
    stateLists$ = [];
    districtLists$ = [];
    districtlist = [];
    userlist = [];
    defaultTestStatus = [{
        "name": 'Testing',
        "id": 'Testing'
    }, {
        "name": 'Trial',
        "id": 'Trial'
    }];
    //groupByList = [];
    groupList = ['Serial No', 'Model'];
    serviceFilterList = ['Delivery Pending'];
    serviceReportTypeList = [];
    printConfig: any = {
        title: '',
        columns: [],
        rows: []
    };
    soaprintConfig: any = {
        title: '',
        columns: [],
        rows: []
    };
    subscribeAuth;
    subscribeBranch;
    searchPlaceHolder = "Search Client ID/Name ...";
    viewTypePlaceholder = "View Type";
    showViewType = true;
    showUserViewType = false;
    showDateFilter = false;
    showViewAllType = false;
    showhvType = true;
    showReferenceType = true;
    showSearch = true;
    showNo = true;
    showha = false;
    showFromDate = true;
    showToDate = true;
    showBranch = true;
    showGroup = false
    showSumFooter = false;
    canExportPrint = false;
    showStatus = false;
    showServiceNo = false;
    showSrfNo = false;
    showTestingStatus = false;
    showdistrict = false;
    showType = false;
    showReportType = false;
    showEmployeeFilter = false;
    showChallanOutno = false;
    showWarranty = false;
    showOctType = false;
    octTypeList: any[] = [];
    showDocLedgerBillType = false;
    docLedgerBillTypeList: any[] = [
        { id: '', name: 'All' },
        { id: 'Testing Bill', name: 'Testing Bill' },
        { id: 'HV', name: 'HV' },
        { id: 'SOA', name: 'SOA' },
        { id: 'Sales Bill', name: 'Sales Bill' }
    ];
    campPromoFolTypeList: any[] = [
        { id: '', name: 'All' },
        { id: 'Follow Up', name: 'Follow Up' },
        { id: 'Done', name: 'Done' },
        { id: 'Close', name: 'Close' },
        { id: 'Not Willing Now', name: 'Not Willing Now' }
    ];
    gloRepDataArr = [];
    footerDataObj = [];//{};
    filteredReference: Observable<any[]>;
    doctorRefList: any[] = [];
    filteredDoctorRef: any[] = [];
    showDoctorRef = false;
    typeCtrl: FormControl;
    empList: any[] = [];
    @ViewChild('printTemplate') printTemplate: TemplateRef<any>;
    @ViewChild('optionTemplate') optionTemplate: TemplateRef<any>;
    @ViewChild('optionTrackTemplate') optionTrackTemplate: TemplateRef<any>;
    @ViewChild('optionActionTemplate') optionActionTemplate: TemplateRef<any>;
    @ViewChild('printPage') printPage;
    @ViewChild('optionImageTemplate') optionImageTemplate: TemplateRef<any>;
    @ViewChild('pointDetailsTemplate') pointDetailsTemplate: TemplateRef<any>;
    @ViewChild('pointDetailsModal') pointDetailsModal: TemplateRef<any>;
    @ViewChild('dynamicFilterTemplate') dynamicFilterTemplate: TemplateRef<any>;
    @ViewChild('reportTable') reportTable: any;

    // Point Details Modal properties
    pointDetailsModalRef: BsModalRef;
    pointHistoryData: any[] = [];
    selectedClient: any = {};
    pointHistoryColumns = [
        { name: 'Date', prop: 'date', width: 120 },
        { name: 'Type', prop: 'type', width: 120 },
        { name: 'Bill No', prop: 'bill_no', width: 120 },
        { name: 'Bill Amount', prop: 'bill_amount', width: 150 },
        { name: 'Earned Points', prop: 'points_earned', width: 150 }
    ];

    hvPrintConfig: any = {
        type: 'hvPrint'
    };
    searchParams: any;
    // @Input() imgPath:string = "assets/serviceImages/";
    @Input() imgPath: string = "serviceImages/";

    usertype = '';
    constructor(public store: Store<fromRootStore.State>, private reportsService: ReportsService, private commonService: CommonService, private octTypeService: OctTypeService, private modalService: BsModalService, public toasterService: ToasterService, private router: Router) {
        this.viewTypeCtrl = new FormControl();
        this.hvTypeCtrl = new FormControl();
        //this.warrantyTypeCtrl = new FormControl();

        function hasValidRef(input: FormControl) {
            let testTypeID = input.value, retVal = null;
            if (testTypeID == "") {
                retVal = { inValidRef: true };
            }
            if (testTypeID && typeof testTypeID === 'string') {
                retVal = { inValidRef: true };
            }
            return retVal;
        }
        this.referenceCtrl = new FormControl('', [
            Validators.required,
            hasValidRef.bind(this)
        ]);
        this.filteredReference = this.referenceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterItems(name) : this.itemList.slice());

        //this.groupByCtrl = new FormControl();
        //this.groupByList = ['Client','Reference'];
        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        //STATUS
        this.statusCtrl = new FormControl();
        this.filteredStatus = this.statusCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterStatus(name) : this.statusList.slice());
        //TESTING STATUS
        this.testStatusCtrl = new FormControl();
        this.filteredTestStatus = this.testStatusCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterTestStatus(name) : this.testStatusList.slice());
    }

    ngOnInit(): void {
        let that = this;
        this.viewTypeList = ['Daily', 'Monthly', 'Yearly'];
        this.hvTypeList = ['HV', 'HV-Recheckup', 'HV-Fitting',
            'HV-ReTrial', 'HV-ReTrial-Fitting'];
        this.filterData['hv_type'] = this.hvTypeList[0];
        this.setPrintConfig();
        this.filterData['type'] = "";
        this.typeList = ['HA Model', 'Spare'];

        //TO LOAD EMPLOYEE LIST 

        this.filteredEmp = this.searchTermsEmp
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.getEmployeeList(term, 'challan')
                // or the observable of empty heroes if there was no search term
                : Observable.of<EmployeeModel[]>([]))
            //.switchMap(term => this.commonService.getEmployeeList(term, 'tt'))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<EmployeeModel[]>([]);
            });

        this.filteredEmp.subscribe(($e) => {
            that.empList = $e;
        });

        //TO LOAD BRANCH COMBO
        this.subscribeBranch = this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
        });
        //TO LOAD REFERENCE COMBO
        this.store.select(fromCommonStore.getAllReference).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                return;
            }
            this.itemList = res;
            this.doctorRefList = res.filter((r: any) => r.source === 'DOCTOR');
            this.filteredDoctorRef = this.doctorRefList;
            that.referenceCtrl.setValue(that.filterData['reference']);
        });
        this.Serviceview = ['Summary View', 'Detail View', 'Count View', 'Service Booking Count', 'Not Ok', 'Detail Service View'];
        this.warranty = ['Warranty', 'Out of Warranty'];
        this.filterData['view'] = 'Summary View';
        //TO HIDE SOME FIELDS IN FILTER
        if (this.params['tabParams'] == 'unsoldDailyFollowUpReport'
            || this.params['tabParams'] == 'soldDailyFollowUpReport'
            || this.params['tabParams'] == 'salesDailyFollowUpReport'
            || this.params['tabParams'] == 'soaDailyFollowUpReport'
            || this.params['tabParams'] == 'hvDailyFollowUpReport'
            || this.params['tabParams'] == 'aftersalesDailyFollowUpReport'
            || this.params['tabParams'] == 'dummysalesDailyFollowUpStatus'
            || this.params['tabParams'] == 'promounsoldDailyFollowUpReport'
            || this.params['tabParams'] == 'phoneTrackingReport'
            || this.params['tabParams'] == 'clientWalkInReport'
            || this.params['tabParams'] == 'afterSalesReport'
            || this.params['tabParams'] == 'branchWiseSold'
            || this.params['tabParams'] == 'monthWiseSold'
            || this.params['tabParams'] == 'dailyStock'
            || this.params['tabParams'] == 'reviewReport'
            || this.params['tabParams'] == 'daybook'
            || this.params['tabParams'] == 'expenseReport'
            || this.params['tabParams'] == 'hvExpenseReport'
            || this.params['tabParams'] == 'purchaseInvoiceReport'
            || this.params['tabParams'] == 'purchaseReturnReport'
            || this.params['tabParams'] == 'unsoldFollowupReport'
            || this.params['tabParams'] == 'soldFollowupReport'
            || this.params['tabParams'] == 'salesFollowupReport'
            || this.params['tabParams'] == 'soaFollowupReport'
            || this.params['tabParams'] == 'hvFollowupReport'
            || this.params['tabParams'] == 'aftersalesFollowupReport'
            || this.params['tabParams'] == 'dummysalesFollowupReport'
            || this.params['tabParams'] == 'promounsoldFollowupReport'
            || this.params['tabParams'] == 'unsoldFollowupHisReport'
            || this.params['tabParams'] == 'soldFollowupHisReport'
            || this.params['tabParams'] == 'salesFollowupHisReport'
            || this.params['tabParams'] == 'soaFollowupHisReport'
            || this.params['tabParams'] == 'hvFollowupHisReport'
            || this.params['tabParams'] == 'aftersalesFollowupHisReport'
            || this.params['tabParams'] == 'dummysalesFollowupHisReport'
            || this.params['tabParams'] == 'promounsoldFollowupHisReport'
            || this.params['tabParams'] == 'unsoldFollowupNotokReport'
            || this.params['tabParams'] == 'soldFollowupNotokReport'
            || this.params['tabParams'] == 'salesFollowupNotokReport'
            || this.params['tabParams'] == 'soaFollowupNotokReport'
            || this.params['tabParams'] == 'hvFollowupNotokReport'
            || this.params['tabParams'] == 'aftersalesFollowupNotokReport'
            || this.params['tabParams'] == 'dummysalesFollowupNotokReport'
            || this.params['tabParams'] == 'promounsoldFollowupNotokReport'
            || this.params['tabParams'] == 'salesReport'
            || this.params['tabParams'] == 'OldClientDailyFollowUpReport'
            || this.params['tabParams'] == 'OldClientFollowupNotokReport'
            || this.params['tabParams'] == 'OldClientFollowupHisReport'
            || this.params['tabParams'] == 'OldClientFollowupReport'
            || this.params['tabParams'] == 'dummysalesDailyFollowUpReport'
            || this.params['tabParams'] == 'overallSalesReport'
            || this.params['tabParams'] == 'callsReport'
            || this.params['tabParams'] == 'notWillingNowDailyFollowUpReport'
            || this.params['tabParams'] == 'notWillingNowNextFollowUpReport'
            || this.params['tabParams'] == 'notWillingNowHisFollowUpReport'
            || this.params['tabParams'] == 'storeDailyFollowUpReport') {
            this.showSearch = false;
        }
        if (this.params['tabParams'] == 'unsoldDailyFollowUpReport'
            || this.params['tabParams'] == 'soldDailyFollowUpReport'
            || this.params['tabParams'] == 'salesDailyFollowUpReport'
            || this.params['tabParams'] == 'soaDailyFollowUpReport'
            || this.params['tabParams'] == 'hvDailyFollowUpReport'
            || this.params['tabParams'] == 'promounsoldDailyFollowUpReport'
            || this.params['tabParams'] == 'aftersalesDailyFollowUpReport'
            || this.params['tabParams'] == 'afterSalesReport'
            || this.params['tabParams'] == 'reviewReport'
            || this.params['tabParams'] == 'OldClientDailyFollowUpReport'
            || this.params['tabParams'] == 'OldClientFollowupNotokReport'
            || this.params['tabParams'] == 'OldClientFollowupHisReport'
            || this.params['tabParams'] == 'unsoldFollowupHisReport'
            || this.params['tabParams'] == 'soldFollowupHisReport'
            || this.params['tabParams'] == 'salesFollowupHisReport'
            || this.params['tabParams'] == 'soaFollowupHisReport'
            || this.params['tabParams'] == 'hvFollowupHisReport'
            || this.params['tabParams'] == 'aftersalesFollowupHisReport'
            || this.params['tabParams'] == 'dummysalesFollowupHisReport'
            || this.params['tabParams'] == 'dummysalesDailyFollowUpReport'
            || this.params['tabParams'] == 'promounsoldFollowupHisReport'
            || this.params['tabParams'] == 'machineSerialHistory'
            || this.params['tabParams'] == 'notWillingNowDailyFollowUpReport'
            || this.params['tabParams'] == 'notWillingNowHisFollowUpReport'
            || this.params['tabParams'] == 'hvCallsCurrentStatusReport'
            || this.params['tabParams'] == 'teleteamPersonWiseReport'
            || this.params['tabParams'] == 'agewisestockreport'
            || this.params['tabParams'] == 'couponPointsReport'
            || this.params['tabParams'] == 'notificationReport'
            || this.params['tabParams'] == 'campPromoReport'
            || this.params['tabParams'] == 'storeDailyFollowUpReport') {
            this.showBranch = false;
        }
        if (this.params['tabParams'] == 'stockReport'
            || this.params['tabParams'] == 'soldDailyFollowUpReport'
            || this.params['tabParams'] == 'soaDailyFollowUpReport'
            || this.params['tabParams'] == 'aftersalesDailyFollowUpReport'
            || this.params['tabParams'] == 'expenseReport'
            || this.params['tabParams'] == 'hvExpenseReport'
            || this.params['tabParams'] == 'hvAppoinmentReport'
            || this.params['tabParams'] == 'soaAppoinmentReport'
            || this.params['tabParams'] == 'allBranchDsr'
            || this.params['tabParams'] == 'allHvReport'
            || this.params['tabParams'] == 'allSoaReport'
            || this.params['tabParams'] == 'purchaseInvoiceReport'
            || this.params['tabParams'] == 'purchaseReturnReport'
            || this.params['tabParams'] == 'spareSalesReport'
            || this.params['tabParams'] == 'salesReturnReport'
            || this.params['tabParams'] == 'advanceReturnReport'
            || this.params['tabParams'] == 'advanceReport'
            || this.params['tabParams'] == 'unsoldPendingReport'
            || this.params['tabParams'] == 'testingReport'
            || this.params['tabParams'] == 'afterSalesReport'
            || this.params['tabParams'] == 'dailyStock'
            || this.params['tabParams'] == 'dailyStockNew'
            || this.params['tabParams'] == 'unsoldFollowupHisReport'
            || this.params['tabParams'] == 'soldFollowupHisReport'
            || this.params['tabParams'] == 'salesFollowupHisReport'
            || this.params['tabParams'] == 'soaFollowupHisReport'
            || this.params['tabParams'] == 'hvFollowupHisReport'
            || this.params['tabParams'] == 'aftersalesFollowupHisReport'
            || this.params['tabParams'] == 'dummysalesFollowupHisReport'
            || this.params['tabParams'] == 'promounsoldFollowupHisReport'
            || this.params['tabParams'] == 'unsoldFollowupReport'
            || this.params['tabParams'] == 'soldFollowupReport'
            || this.params['tabParams'] == 'salesFollowupReport'
            || this.params['tabParams'] == 'soaFollowupReport'
            || this.params['tabParams'] == 'hvFollowupReport'
            || this.params['tabParams'] == 'aftersalesFollowupReport'
            || this.params['tabParams'] == 'dummysalesFollowupReport'
            || this.params['tabParams'] == 'promounsoldFollowupReport'
            || this.params['tabParams'] == 'soldDailyFollowUpReport'
            || this.params['tabParams'] == 'soaDailyFollowUpReport'
            || this.params['tabParams'] == 'aftersalesDailyFollowUpReport'
            || this.params['tabParams'] == 'dummysalesDailyFollowUpStatus'
            || this.params['tabParams'] == 'promounsoldDailyFollowUpReport'
            || this.params['tabParams'] == 'unsoldFollowupNotokReport'
            || this.params['tabParams'] == 'soldFollowupNotokReport'
            || this.params['tabParams'] == 'salesFollowupNotokReport'
            || this.params['tabParams'] == 'soaFollowupNotokReport'
            || this.params['tabParams'] == 'hvFollowupNotokReport'
            || this.params['tabParams'] == 'aftersalesFollowupNotokReport'
            || this.params['tabParams'] == 'dummysalesFollowupNotokReport'
            || this.params['tabParams'] == 'promounsoldFollowupNotokReport'
            || this.params['tabParams'] == 'daybook'
            || this.params['tabParams'] == 'netServiceReport'
            //|| this.params['tabParams'] == 'doctorReport'
            || this.params['tabParams'] == 'format3NetWalkins'
            || this.params['tabParams'] == 'serviceTrackingReport'
            || this.params['tabParams'] == 'clientWalkInDetailReport'
            || this.params['tabParams'] == 'OldClientDailyFollowUpReport'
            || this.params['tabParams'] == 'OldClientFollowupNotokReport'
            || this.params['tabParams'] == 'OldClientFollowupHisReport'
            || this.params['tabParams'] == 'OldClientFollowupReport'
            || this.params['tabParams'] == 'notSatisfiedReport'
            || this.params['tabParams'] == 'notSatisfiedToSatisfiedReport'
            //|| this.params['tabParams'] == 'dummysalesDailyFollowUpReport'
            || this.params['tabParams'] == 'promounsoldFollowupHisReport'
            || this.params['tabParams'] == 'overallSalesReport'
            || this.params['tabParams'] == 'machineSerialHistory'
            || this.params['tabParams'] == 'salesReport'
            || this.params['tabParams'] == 'purchaseAgainstSrfReport'
            || this.params['tabParams'] == 'HvSoaEmployeeStockReport'
            || this.params['tabParams'] == 'srfEstimationAgainstBillAmt'
            || this.params['tabParams'] == 'callsReport'
            || this.params['tabParams'] == 'salesCurrentStatusReport'
            || this.params['tabParams'] == 'hvCallsCurrentStatusReport'
            || this.params['tabParams'] == 'agewisestockreport'
            || this.params['tabParams'] == 'srfPendingReport'
            || this.params['tabParams'] == 'couponPointsReport') {
            this.showViewType = false;
        }
        if (this.params['tabParams'] == 'stockReport'
            || this.params['tabParams'] == 'unsoldFollowupHisReport'
            || this.params['tabParams'] == 'soldFollowupHisReport'
            || this.params['tabParams'] == 'salesFollowupHisReport'
            || this.params['tabParams'] == 'soaFollowupHisReport'
            || this.params['tabParams'] == 'hvFollowupHisReport'
            || this.params['tabParams'] == 'aftersalesFollowupHisReport'
            || this.params['tabParams'] == 'dummysalesFollowupHisReport'
            || this.params['tabParams'] == 'promounsoldFollowupHisReport'
            || this.params['tabParams'] == 'unsoldFollowupReport'
            || this.params['tabParams'] == 'soldFollowupReport'
            || this.params['tabParams'] == 'salesFollowupReport'
            || this.params['tabParams'] == 'soaFollowupReport'
            || this.params['tabParams'] == 'hvFollowupReport'
            || this.params['tabParams'] == 'aftersalesFollowupReport'
            || this.params['tabParams'] == 'dummysalesFollowupReport'
            || this.params['tabParams'] == 'promounsoldFollowupReport'
            || this.params['tabParams'] == 'unsoldDailyFollowUpReport'
            || this.params['tabParams'] == 'soldDailyFollowUpReport'
            || this.params['tabParams'] == 'salesDailyFollowUpReport'
            || this.params['tabParams'] == 'soaDailyFollowUpReport'
            || this.params['tabParams'] == 'hvDailyFollowUpReport'
            || this.params['tabParams'] == 'aftersalesDailyFollowUpReport'
            || this.params['tabParams'] == 'dummysalesDailyFollowUpStatus'
            || this.params['tabParams'] == 'promounsoldDailyFollowUpReport'
            || this.params['tabParams'] == 'unsoldFollowupNotokReport'
            || this.params['tabParams'] == 'soldFollowupNotokReport'
            || this.params['tabParams'] == 'salesFollowupNotokReport'
            || this.params['tabParams'] == 'soaFollowupNotokReport'
            || this.params['tabParams'] == 'hvFollowupNotokReport'
            || this.params['tabParams'] == 'aftersalesFollowupNotokReport'
            || this.params['tabParams'] == 'dummysalesFollowupNotokReport'
            || this.params['tabParams'] == 'promounsoldFollowupNotokReport'
            || this.params['tabParams'] == 'expenseReport'
            || this.params['tabParams'] == 'hvExpenseReport'
            || this.params['tabParams'] == 'allBranchDsr'
            || this.params['tabParams'] == 'allHvReport'
            || this.params['tabParams'] == 'allSoaReport'
            || this.params['tabParams'] == 'afterSalesReport'
            || this.params['tabParams'] == 'purchaseInvoiceReport'
            || this.params['tabParams'] == 'purchaseReturnReport'
            || this.params['tabParams'] == 'spareSalesReport'
            || this.params['tabParams'] == 'salesReturnReport'
            || this.params['tabParams'] == 'advanceReturnReport'
            || this.params['tabParams'] == 'advanceReport'
            || this.params['tabParams'] == 'unsoldPendingReport'
            || this.params['tabParams'] == 'salesCurrentStatusReport'
            || this.params['tabParams'] == 'testingReport'
            || this.params['tabParams'] == 'afterSalesReport'
            || this.params['tabParams'] == 'doctorReport'
            || this.params['tabParams'] == 'serviceTrackingReport'
            || this.params['tabParams'] == 'netServiceReport'
            || this.params['tabParams'] == 'hvTrack'
            || this.params['tabParams'] == 'phTracking'
            || this.params['tabParams'] == 'branchWiseSold'
            || this.params['tabParams'] == 'monthWiseSold'
            || this.params['tabParams'] == 'dailyStock'
            || this.params['tabParams'] == 'dailyStockNew'
            || this.params['tabParams'] == 'soaAppoinmentReport'
            || this.params['tabParams'] == 'reviewReport'
            || this.params['tabParams'] == 'phoneTrackingReport'
            || this.params['tabParams'] == 'daybook'
            || this.params['tabParams'] == 'format3NetWalkins'
            || this.params['tabParams'] == 'clientWalkInDetailReport'
            || this.params['tabParams'] == 'clientWalkInReport'
            || this.params['tabParams'] == 'salesReport'
            || this.params['tabParams'] == 'OldClientDailyFollowUpReport'
            || this.params['tabParams'] == 'OldClientFollowupNotokReport'
            || this.params['tabParams'] == 'OldClientFollowupHisReport'
            || this.params['tabParams'] == 'OldClientFollowupReport'
            || this.params['tabParams'] == 'notSatisfiedReport'
            || this.params['tabParams'] == 'notSatisfiedToSatisfiedReport'
            || this.params['tabParams'] == 'dummysalesDailyFollowUpReport'
            || this.params['tabParams'] == 'promounsoldFollowupHisReport'
            || this.params['tabParams'] == 'overallSalesReport'
            || this.params['tabParams'] == 'machineSerialHistory'
            || this.params['tabParams'] == 'purchaseAgainstSrfReport'
            || this.params['tabParams'] == 'HvSoaEmployeeStockReport'
            || this.params['tabParams'] == 'srfEstimationAgainstBillAmt'
            || this.params['tabParams'] == 'callsReport'
            || this.params['tabParams'] == 'notWillingNowDailyFollowUpReport'
            || this.params['tabParams'] == 'notWillingNowNextFollowUpReport'
            || this.params['tabParams'] == 'notWillingNowHisFollowUpReport'
            || this.params['tabParams'] == 'hvCallsCurrentStatusReport'
            || this.params['tabParams'] == 'teleteamPersonWiseReport'
            || this.params['tabParams'] == 'agewisestockreport'
            || this.params['tabParams'] == 'srfPendingReport'
            || this.params['tabParams'] == 'notificationReport'
            || this.params['tabParams'] == 'campPromoReport'
            || this.params['tabParams'] == 'storeDailyFollowUpReport') {
            this.showhvType = false;
        }
        if (this.params['tabParams'] == 'stockReport'
            || this.params['tabParams'] == 'unsoldFollowupHisReport'
            || this.params['tabParams'] == 'soldFollowupHisReport'
            || this.params['tabParams'] == 'salesFollowupHisReport'
            || this.params['tabParams'] == 'soaFollowupHisReport'
            || this.params['tabParams'] == 'hvFollowupHisReport'
            || this.params['tabParams'] == 'aftersalesFollowupHisReport'
            || this.params['tabParams'] == 'dummysalesFollowupHisReport'
            || this.params['tabParams'] == 'promounsoldFollowupHisReport'
            || this.params['tabParams'] == 'unsoldFollowupReport'
            || this.params['tabParams'] == 'soldFollowupReport'
            || this.params['tabParams'] == 'salesFollowupReport'
            || this.params['tabParams'] == 'soaFollowupReport'
            || this.params['tabParams'] == 'hvFollowupReport'
            || this.params['tabParams'] == 'aftersalesFollowupReport'
            || this.params['tabParams'] == 'dummysalesFollowupReport'
            || this.params['tabParams'] == 'promounsoldFollowupReport'
            || this.params['tabParams'] == 'unsoldDailyFollowUpReport'
            || this.params['tabParams'] == 'soldDailyFollowUpReport'
            || this.params['tabParams'] == 'salesDailyFollowUpReport'
            || this.params['tabParams'] == 'soaDailyFollowUpReport'
            || this.params['tabParams'] == 'hvDailyFollowUpReport'
            || this.params['tabParams'] == 'aftersalesDailyFollowUpReport'
            || this.params['tabParams'] == 'dummysalesDailyFollowUpStatus'
            || this.params['tabParams'] == 'promounsoldDailyFollowUpReport'
            || this.params['tabParams'] == 'unsoldFollowupNotokReport'
            || this.params['tabParams'] == 'soldFollowupNotokReport'
            || this.params['tabParams'] == 'salesFollowupNotokReport'
            || this.params['tabParams'] == 'soaFollowupNotokReport'
            || this.params['tabParams'] == 'hvFollowupNotokReport'
            || this.params['tabParams'] == 'aftersalesFollowupNotokReport'
            || this.params['tabParams'] == 'dummysalesFollowupNotokReport'
            || this.params['tabParams'] == 'promounsoldFollowupNotokReport'
            || this.params['tabParams'] == 'expenseReport'
            || this.params['tabParams'] == 'hvExpenseReport'
            || this.params['tabParams'] == 'allHvReport'
            || this.params['tabParams'] == 'allSoaReport'
            || this.params['tabParams'] == 'afterSalesReport'
            || this.params['tabParams'] == 'purchaseInvoiceReport'
            || this.params['tabParams'] == 'purchaseReturnReport'
            || this.params['tabParams'] == 'spareSalesReport'
            || this.params['tabParams'] == 'salesReturnReport'
            || this.params['tabParams'] == 'advanceReturnReport'
            || this.params['tabParams'] == 'advanceReport'
            || this.params['tabParams'] == 'unsoldPendingReport'
            || this.params['tabParams'] == 'salesCurrentStatusReport'
            || this.params['tabParams'] == 'hvCallsCurrentStatusReport'
            || this.params['tabParams'] == 'testingReport'
            || this.params['tabParams'] == 'afterSalesReport'
            || this.params['tabParams'] == 'doctorReport'
            || this.params['tabParams'] == 'serviceTrackingReport'
            || this.params['tabParams'] == 'netServiceReport'
            || this.params['tabParams'] == 'hvTrack'
            || this.params['tabParams'] == 'phTracking'
            || this.params['tabParams'] == 'branchWiseSold'
            || this.params['tabParams'] == 'monthWiseSold'
            || this.params['tabParams'] == 'dailyStock'
            || this.params['tabParams'] == 'dailyStockNew'
            || this.params['tabParams'] == 'hvAppoinmentReport'
            || this.params['tabParams'] == 'allBranchDsr'
            || this.params['tabParams'] == 'phoneTrackingReport'
            || this.params['tabParams'] == 'daybook'
            || this.params['tabParams'] == 'format3NetWalkins'
            || this.params['tabParams'] == 'clientWalkInDetailReport'
            || this.params['tabParams'] == 'clientWalkInReport'
            || this.params['tabParams'] == 'salesReport'
            || this.params['tabParams'] == 'OldClientDailyFollowUpReport'
            || this.params['tabParams'] == 'OldClientFollowupNotokReport'
            || this.params['tabParams'] == 'OldClientFollowupHisReport'
            || this.params['tabParams'] == 'OldClientFollowupReport'
            || this.params['tabParams'] == 'notSatisfiedReport'
            || this.params['tabParams'] == 'notSatisfiedToSatisfiedReport'
            || this.params['tabParams'] == 'dummysalesDailyFollowUpReport'
            || this.params['tabParams'] == 'promounsoldFollowupHisReport'
            || this.params['tabParams'] == 'reviewReport'
            || this.params['tabParams'] == 'overallSalesReport'
            || this.params['tabParams'] == 'machineSerialHistory'
            || this.params['tabParams'] == 'purchaseAgainstSrfReport'
            || this.params['tabParams'] == 'HvSoaEmployeeStockReport'
            || this.params['tabParams'] == 'srfEstimationAgainstBillAmt'
            || this.params['tabParams'] == 'callsReport'
            || this.params['tabParams'] == 'notWillingNowDailyFollowUpReport'
            || this.params['tabParams'] == 'notWillingNowNextFollowUpReport'
            || this.params['tabParams'] == 'notWillingNowHisFollowUpReport'
            || this.params['tabParams'] == 'teleteamPersonWiseReport'
            || this.params['tabParams'] == 'agewisestockreport'
            || this.params['tabParams'] == 'srfPendingReport'
            || this.params['tabParams'] == 'couponPointsReport'
            || this.params['tabParams'] == 'notificationReport'
            || this.params['tabParams'] == 'storeDailyFollowUpReport'
            || this.params['tabParams'] == 'octReport'
            || this.params['tabParams'] == 'tnwReport'
            || this.params['tabParams'] == 'unsoldDetailReport'
            || this.params['tabParams'] == 'bilateralWillingReport'
            || this.params['tabParams'] == 'advanceDetailReport'
            || this.params['tabParams'] == 'allPromoReport'
            || this.params['tabParams'] == 'fbLeadReport'
            || this.params['tabParams'] == 'rocReferralReport'
            || this.params['tabParams'] == 'notWillingNowReport'
            || this.params['tabParams'] == 'docLedgerReport'
            || this.params['tabParams'] == 'docTestingLedgerReport') {
            this.showReferenceType = false;

        }
        if (this.params['tabParams'] == 'stockReport'
            || this.params['tabParams'] == 'unsoldFollowupHisReport'
            || this.params['tabParams'] == 'soldFollowupHisReport'
            || this.params['tabParams'] == 'salesFollowupHisReport'
            || this.params['tabParams'] == 'soaFollowupHisReport'
            || this.params['tabParams'] == 'hvFollowupHisReport'
            || this.params['tabParams'] == 'aftersalesFollowupHisReport'
            || this.params['tabParams'] == 'dummysalesFollowupHisReport'
            || this.params['tabParams'] == 'promounsoldFollowupHisReport'
            || this.params['tabParams'] == 'unsoldFollowupReport'
            || this.params['tabParams'] == 'soldFollowupReport'
            || this.params['tabParams'] == 'salesFollowupReport'
            || this.params['tabParams'] == 'soaFollowupReport'
            || this.params['tabParams'] == 'hvFollowupReport'
            || this.params['tabParams'] == 'aftersalesFollowupReport'
            || this.params['tabParams'] == 'dummysalesFollowupReport'
            || this.params['tabParams'] == 'promounsoldFollowupReport'
            || this.params['tabParams'] == 'unsoldDailyFollowUpReport'
            || this.params['tabParams'] == 'soldDailyFollowUpReport'
            || this.params['tabParams'] == 'salesDailyFollowUpReport'
            || this.params['tabParams'] == 'soaDailyFollowUpReport'
            || this.params['tabParams'] == 'hvDailyFollowUpReport'
            || this.params['tabParams'] == 'aftersalesDailyFollowUpReport'
            || this.params['tabParams'] == 'dummysalesDailyFollowUpStatus'
            || this.params['tabParams'] == 'promounsoldDailyFollowUpReport'
            || this.params['tabParams'] == 'unsoldFollowupNotokReport'
            || this.params['tabParams'] == 'soldFollowupNotokReport'
            || this.params['tabParams'] == 'salesFollowupNotokReport'
            || this.params['tabParams'] == 'soaFollowupNotokReport'
            || this.params['tabParams'] == 'hvFollowupNotokReport'
            || this.params['tabParams'] == 'aftersalesFollowupNotokReport'
            || this.params['tabParams'] == 'dummysalesFollowupNotokReport'
            || this.params['tabParams'] == 'promounsoldFollowupNotokReport'
            || this.params['tabParams'] == 'expenseReport'
            || this.params['tabParams'] == 'hvExpenseReport'
            || this.params['tabParams'] == 'allHvReport'
            || this.params['tabParams'] == 'allSoaReport'
            || this.params['tabParams'] == 'afterSalesReport'
            || this.params['tabParams'] == 'purchaseInvoiceReport'
            || this.params['tabParams'] == 'purchaseReturnReport'
            || this.params['tabParams'] == 'spareSalesReport'
            || this.params['tabParams'] == 'salesReturnReport'
            || this.params['tabParams'] == 'advanceReturnReport'
            || this.params['tabParams'] == 'advanceReport'
            || this.params['tabParams'] == 'unsoldPendingReport'
            || this.params['tabParams'] == 'salesCurrentStatusReport'
            || this.params['tabParams'] == 'testingReport'
            || this.params['tabParams'] == 'afterSalesReport'
            || this.params['tabParams'] == 'doctorReport'
            || this.params['tabParams'] == 'serviceTrackingReport'
            || this.params['tabParams'] == 'netServiceReport'
            || this.params['tabParams'] == 'hvTrack'
            || this.params['tabParams'] == 'phTracking'
            || this.params['tabParams'] == 'branchWiseSold'
            || this.params['tabParams'] == 'monthWiseSold'
            || this.params['tabParams'] == 'hvAppoinmentReport'
            || this.params['tabParams'] == 'reviewReport'
            || this.params['tabParams'] == 'allBranchDsr'
            || this.params['tabParams'] == 'phoneTrackingReport'
            || this.params['tabParams'] == 'daybook'
            || this.params['tabParams'] == 'format3NetWalkins'
            || this.params['tabParams'] == 'clientWalkInDetailReport'
            || this.params['tabParams'] == 'clientWalkInReport'
            || this.params['tabParams'] == 'salesReport'
            || this.params['tabParams'] == 'soaAppoinmentReport'
            || this.params['tabParams'] == 'OldClientDailyFollowUpReport'
            || this.params['tabParams'] == 'OldClientFollowupNotokReport'
            || this.params['tabParams'] == 'OldClientFollowupHisReport'
            || this.params['tabParams'] == 'OldClientFollowupReport'
            || this.params['tabParams'] == 'notSatisfiedReport'
            || this.params['tabParams'] == 'notSatisfiedToSatisfiedReport'
            || this.params['tabParams'] == 'dummysalesDailyFollowUpReport'
            || this.params['tabParams'] == 'promounsoldFollowupHisReport'
            || this.params['tabParams'] == 'overallSalesReport'
            || this.params['tabParams'] == 'machineSerialHistory'
            || this.params['tabParams'] == 'purchaseAgainstSrfReport'
            || this.params['tabParams'] == 'HvSoaEmployeeStockReport'
            || this.params['tabParams'] == 'srfEstimationAgainstBillAmt'
            || this.params['tabParams'] == 'callsReport'
            || this.params['tabParams'] == 'notWillingNowDailyFollowUpReport'
            || this.params['tabParams'] == 'notWillingNowNextFollowUpReport'
            || this.params['tabParams'] == 'notWillingNowHisFollowUpReport'
            || this.params['tabParams'] == 'hvCallsCurrentStatusReport'
            || this.params['tabParams'] == 'teleteamPersonWiseReport'
            || this.params['tabParams'] == 'agewisestockreport'
            || this.params['tabParams'] == 'dailyStockNew'
            || this.params['tabParams'] == 'srfPendingReport'
            || this.params['tabParams'] == 'notificationReport'
            || this.params['tabParams'] == 'campPromoReport'
            || this.params['tabParams'] == 'storeDailyFollowUpReport'
            || this.params['tabParams'] == 'octReport'
            || this.params['tabParams'] == 'unsoldDetailReport'
            || this.params['tabParams'] == 'bilateralWillingReport'
            || this.params['tabParams'] == 'advanceDetailReport'
            || this.params['tabParams'] == 'allPromoReport'
            || this.params['tabParams'] == 'fbLeadReport'
            || this.params['tabParams'] == 'rocReferralReport'
            || this.params['tabParams'] == 'notWillingNowReport'
            || this.params['tabParams'] == 'docLedgerReport'
            || this.params['tabParams'] == 'docTestingLedgerReport') {
            this.showNo = false;
        }
        if (this.params['tabParams'] == 'stockReport'
            || this.params['tabParams'] == 'serviceTrackingReport'
            || this.params['tabParams'] == 'notSatisfiedReport'
            || this.params['tabParams'] == 'machineSerialHistory'
            || this.params['tabParams'] == 'couponPointsReport'
            || this.params['tabParams'] == 'agewisestockreport') {
            this.showFromDate = false;
        }
        if (this.params['tabParams'] == 'serviceTrackingReport') {
            this.searchPlaceHolder = "Search Client ID/Name/Mobile No ...";
            this.showServiceNo = true;
            this.showServiceView = true;
        }
        if (this.params['tabParams'] == 'purchaseAgainstSrfReport') {
            this.serviceReportTypeList = ['Pending', 'Completed', 'Both'];
            this.searchPlaceHolder = "Search Client ID/Name/Mobile No ...";
            this.showServiceNo = true;
            this.showReportType = true;
            this.showFromDate = false;
            this.showToDate = false;
            this.filterData['report_type'] = 'Pending';
        }
        if (this.params['tabParams'] == 'srfEstimationAgainstBillAmt') {
            this.serviceReportTypeList = ['Above 20%', 'Below 20%'];
            this.searchPlaceHolder = "Search Client ID/Name/Mobile No ...";
            this.showServiceNo = true;
            this.showReportType = true;
            this.filterData['report_type'] = 'Below 20%';
        }
        if (this.params['tabParams'] == 'HvSoaEmployeeStockReport') {
            this.showEmployeeFilter = true;
            this.showChallanOutno = true;
            this.searchPlaceHolder = "Search Brand/Brand Model/Serial No ...";
        }
        if (this.params['tabParams'] == 'stockReport') {
            this.showha = true;
            this.showGroup = true;
        }
        if (this.params['tabParams'] == 'dailyStockNew') {
            this.showha = true;
        }
        if (this.params['tabParams'] == 'allBranchDsr') {
            this.showdistrict = true;
            this.showReferenceType = true;
        }
        if (this.params['tabParams'] == 'octReport') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showdistrict = false;
            this.showViewType = false;
            this.showhvType = false;
            this.showOctType = true;
            this.octTypeService.getOctTypeList({}).then(function (res: any) {
                that.octTypeList = res.data || res;
            });
        }
        if (this.params['tabParams'] == 'tnwReport') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showViewType = false;
            this.showhvType = false;
            this.showNo = false;
        }
        if (this.params['tabParams'] == 'unsoldDetailReport') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showViewType = false;
            this.showhvType = false;
            this.showNo = false;
        }
        if (this.params['tabParams'] == 'bilateralWillingReport') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showViewType = false;
            this.showhvType = false;
            this.showNo = false;
        }
        if (this.params['tabParams'] == 'advanceDetailReport') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showViewType = false;
            this.showhvType = false;
            this.showNo = false;
        }
        if (this.params['tabParams'] == 'allPromoReport') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showViewType = false;
            this.showhvType = false;
            this.showNo = false;
        }
        if (this.params['tabParams'] == 'fbLeadReport') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showViewType = false;
            this.showhvType = false;
            this.showNo = false;
        }
        if (this.params['tabParams'] == 'rocReferralReport') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showViewType = false;
            this.showhvType = false;
            this.showNo = false;
        }
        if (this.params['tabParams'] == 'notWillingNowReport') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showViewType = false;
            this.showhvType = false;
            this.showNo = false;
        }
        if (this.params['tabParams'] == 'docLedgerReport') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showViewType = false;
            this.showhvType = false;
            this.showNo = false;
            this.showDocLedgerBillType = true;
            this.showDoctorRef = true;
        }
        if (this.params['tabParams'] == 'docTestingLedgerReport') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showViewType = false;
            this.showhvType = false;
            this.showNo = false;
            this.showDoctorRef = true;
        }
        if (this.params['tabParams'] == 'clientHistoryReport') {
            this.searchPlaceHolder = "Search Client ID / Name / Mobile ...";
            // Reset all filters to false first
            this.showViewType = false;
            this.showUserViewType = false;
            this.showDateFilter = false;
            this.showViewAllType = false;
            this.showhvType = false;
            this.showReferenceType = false;
            this.showSearch = false;
            this.showNo = false;
            this.showha = false;
            this.showFromDate = false;
            this.showToDate = false;
            this.showBranch = false;
            this.showGroup = false;
            this.showSumFooter = false;
            this.showStatus = false;
            this.showServiceNo = false;
            this.showSrfNo = false;
            this.showTestingStatus = false;
            this.showdistrict = false;
            this.showType = false;
            this.showReportType = false;
            this.showEmployeeFilter = false;
            this.showChallanOutno = false;
            this.showWarranty = false;

            // Enable only the required filters for client history report
            this.showSearch = true;
            this.showFromDate = true;
            this.showToDate = true;
            this.showBranch = true;
            this.showReferenceType = true;
            this.showDateFilter = true; // Show the "without date" checkbox
        }
        if (this.params['tabParams'] == 'referralReport') {
            this.searchPlaceHolder = "Search Client ID / Name / Mobile ...";
            // Reset all filters to false first
            this.showViewType = false;
            this.showUserViewType = false;
            this.showDateFilter = false;
            this.showViewAllType = false;
            this.showhvType = false;
            this.showReferenceType = false;
            this.showSearch = false;
            this.showNo = false;
            this.showha = false;
            this.showFromDate = false;
            this.showToDate = false;
            this.showBranch = false;
            this.showGroup = false;
            this.showSumFooter = false;
            this.showStatus = false;
            this.showServiceNo = false;
            this.showSrfNo = false;
            this.showTestingStatus = false;
            this.showdistrict = false;
            this.showType = false;
            this.showReportType = false;
            this.showEmployeeFilter = false;
            this.showChallanOutno = false;
            this.showWarranty = false;

            // Enable only the required filters for referral report
            this.showSearch = true;
            this.showFromDate = true;
            this.showToDate = true;
            this.showBranch = true;
            this.showReferenceType = true;
            this.showDateFilter = true; // Show the "without date" checkbox
        }
        if (this.params['tabParams'] == 'stockReport'
            || this.params['tabParams'] == 'serviceTrackingReport'
            || this.params['tabParams'] == 'notSatisfiedReport'
            || this.params['tabParams'] == 'machineSerialHistory'
            || this.params['tabParams'] == 'couponPointsReport'
            || this.params['tabParams'] == 'agewisestockreport') {
            this.showToDate = false;
        }
        if (this.params['tabParams'] == 'notSatisfiedToSatisfiedReport') {
            this.showWarranty = true;
            this.filterData['warranty_type'] = 'Warranty';
        }
        /*if (this.params['tabParams'] == 'salesReport') {
            this.viewTypeList = ['All', 'Brand Wise', 'Brand Model Wise', 'Family Wise', 'HA Model Wise'];
            this.filterData['view_type'] = 'All';
        } else*/ if (this.params['tabParams'] == 'stockReport') {
            this.searchPlaceHolder = "Search Brand/Brand Model/Serial No ...";
        } else if (this.params['tabParams'] == 'dailyStockNew') {
            this.searchPlaceHolder = "Search Brand Model ...";
        } else if (this.params['tabParams'] == 'allBranchDsr') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showStatus = true;
            this.showTestingStatus = true;
            //TO LOAD FOLLOW UP STATUS COMBO
            this.store.select(fromCommonStore.getAllFollowUpStatus).subscribe((res: any) => {
                if (_.isEmpty(res.data)) {
                    return;
                }
                that.statusList = _.filter(res.data, function (obj) { return obj['name'] != '' });
            });
            //TESTING STATUS
            this.commonService
                .getTestingtypeList()
                .then(function (res: any) {
                    //TO JOIN BOTH ARRAY
                    that.testStatusList = that.defaultTestStatus.concat(res);
                    that.testStatusCtrl.setValue(that.filterData['test_id']);
                });
        } else if (this.params['tabParams'] == 'allHvReport') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showReferenceType = true;
            this.showStatus = true;
            //TO LOAD FOLLOW UP STATUS COMBO
            this.store.select(fromCommonStore.getAllFollowUpStatus).subscribe((res: any) => {
                if (_.isEmpty(res.data)) {
                    return;
                }
                that.statusList = _.filter(res.data, function (obj) { return obj['name'] != '' });
            });
        } else if (this.params['tabParams'] == 'allSoaReport') {
            this.searchPlaceHolder = "Search Client Name / No...";
            this.showReferenceType = true;
            this.showStatus = true;
            //TO LOAD FOLLOW UP STATUS COMBO
            this.store.select(fromCommonStore.getAllFollowUpStatus).subscribe((res: any) => {
                if (_.isEmpty(res.data)) {
                    return;
                }
                that.statusList = _.filter(res.data, function (obj) { return obj['name'] != '' });
            });
        } else if (this.params['tabParams'] == 'expenseReport') {
            this.searchPlaceHolder = "Search Purcahse Invoice No/Party Name ...";
        } else if (this.params['tabParams'] == 'hvExpenseReport') {
            this.searchPlaceHolder = "Search Client ID/Name ...";
        } else if (this.params['tabParams'] == 'purchaseInvoiceReport') {
            this.searchPlaceHolder = "Search Purcahse Return No/Party Name ...";
        } else if (this.params['tabParams'] == 'purchaseReturnReport') {
            this.searchPlaceHolder = "Search Ledger Name...";
        } else if (this.params['tabParams'] == 'spareSalesReport') {
            this.searchPlaceHolder = "Search Spare Name...";
        } else if (this.params['tabParams'] == 'salesReturnReport') {
            this.searchPlaceHolder = "Search Sales Return Name...";
        } else if (this.params['tabParams'] == 'advanceReturnReport') {
            this.searchPlaceHolder = "Search Advance Return Name...";
        } else if (this.params['tabParams'] == 'advanceReport') {
            this.searchPlaceHolder = "Search Advance Name...";
            this.showReferenceType = true;
        } else if (this.params['tabParams'] == 'unsoldPendingReport') {
            this.searchPlaceHolder = "Search Unsold Pending Name...";
        } else if (this.params['tabParams'] == 'salesCurrentStatusReport') {
            this.searchPlaceHolder = "Search Sales Current Status Name...";
        } else if (this.params['tabParams'] == 'hvCallsCurrentStatusReport') {
            this.searchPlaceHolder = "Search HV Calls Current Status Name...";
        } else if (this.params['tabParams'] == 'notificationReport') {
            this.searchPlaceHolder = "Search Client ID/Name...";
            this.showViewType = true;
            this.viewTypePlaceholder = "Assign To";
            this.userListMap = {}; // Reset mapping
            this.isNotificationFilterDisabled = false;

            // Load user list for Assign To dropdown
            this.reportsService.getNotificationUserList().then((res: any) => {
                const currentUser = res.currentUser;
                const users = res.users;

                // Check if user is admin
                if (currentUser.isAdmin) {
                    // Admin: Show all users with "All" option
                    that.viewTypeList = ['All'];
                    that.userListMap['All'] = 0;
                    that.filterData['view_type'] = 'All';
                    that.isNotificationFilterDisabled = false;

                    if (users && users.length > 0) {
                        users.forEach((user: any) => {
                            that.viewTypeList.push(user.fullname);
                            that.userListMap[user.fullname] = user.userid;
                        });
                    }
                } else {
                    // Non-admin: Show only their name, disable filter
                    that.viewTypeList = [currentUser.fullname];
                    that.userListMap[currentUser.fullname] = currentUser.userid;
                    that.filterData['view_type'] = currentUser.fullname;
                    that.isNotificationFilterDisabled = true; // Disable the dropdown
                }
            }).catch((err: any) => {
                console.log('Error loading user list:', err);
            });
        } else if (this.params['tabParams'] == 'teleteamPersonWiseReport') {
            this.searchPlaceHolder = "Search Employee Name...";
            this.showEmployeeFilter = true;
            this.showViewType = false;
            this.viewTypeList = [];
            this.filterData['view_type'] = '';
            this.filterData['empid'] = 0;
        } else if (this.params['tabParams'] == 'testingReport') {
            this.searchPlaceHolder = "Search Testing Name...";
        } else if (this.params['tabParams'] == 'phoneTrackingReport') {
            this.viewTypeList = ['Overall', 'Follow Up', 'Reference', 'Call Attend By'];
            this.filterData['view_type'] = 'Overall';
        } else if (this.params['tabParams'] == 'clientWalkInReport') {
            this.viewTypeList = ['Overall', 'Reference'];
            this.filterData['view_type'] = 'Overall';
        } else if (this.params['tabParams'] == 'monthWiseSold') {
            this.viewTypeList = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
            //TO GET CURRENT MONTH NUMBER 
            this.filterData['view_type'] = moment().format('MM');
        } else if (this.params['tabParams'] == 'reviewReport') {
            //this.viewTypeList = ['Unsold', 'Sales & FB', 'Sales', 'FB', 'HV'];
            this.showType = true;
            this.viewTypeList = ['Unsold', 'Sales', 'Dummy Sales', 'HV', 'OLD CLIENT', 'Not Willing Now'];
            this.filterData['view_type'] = 'Unsold';
            this.showDateFilter = true;
        } else if (this.params['tabParams'] == 'netServiceReport') {
            this.showhvType = false;
            this.showViewType = false;
        } else if (this.params['tabParams'] == 'dummysalesDailyFollowUpReport'
            || this.params['tabParams'] == 'soldDailyFollowUpReport'
            || this.params['tabParams'] == 'soaDailyFollowUpReport'
            || this.params['tabParams'] == 'promounsoldDailyFollowUpReport') {
            this.viewTypeList = ['Daily', 'Weekly', 'Current Total Calls', 'Trial Conversion'];
            this.filterData['view_type'] = 'Daily';
            this.showViewType = true;
            this.showViewAllType = true;

        }
        else if (this.params['tabParams'] == 'hvDailyFollowUpReport'
        ) {
            this.viewTypeList = ['Daily', 'Weekly', 'New Calls', 'New HV', 'Current Total Calls'];
            this.filterData['view_type'] = 'Daily';
            this.showViewType = true;
            this.filterData['followup_id'] = '1';
            this.showDateFilter = true;
        } else if (this.params['tabParams'] == 'OldClientDailyFollowUpReport'
        ) {
            this.viewTypeList = ['Daily', 'Weekly', 'HV Conversion', 'Monthly', 'Trial Conversion', 'New Calls', 'Current Total Calls'];
            this.filterData['view_type'] = 'Daily';
            this.showViewType = true;
            this.filterData['followup_id'] = '10';
        }
        else if (this.params['tabParams'] == 'aftersalesDailyFollowUpReport'
        ) {
            this.viewTypeList = ['Daily', 'Weekly', 'New Calls Details', 'Current Total Calls'];
            this.filterData['view_type'] = 'Daily';
            this.showViewType = true;
            this.filterData['followup_id'] = '7';
        }
        else if (this.params['tabParams'] == 'unsoldDailyFollowUpReport'
        ) {
            this.viewTypeList = ['Daily', 'Weekly', 'Unsold Conversion', 'New Calls', 'Current Total Calls'];
            this.filterData['view_type'] = 'Daily';
            this.showViewType = true;
            this.filterData['followup_id'] = '5';
        }
        else if (this.params['tabParams'] == 'salesDailyFollowUpReport'
        ) {
            this.viewTypeList = ['Daily', 'Weekly', 'New Calls', 'Trial Conversion', 'HV Conversion', 'Current Total Calls'];
            this.filterData['view_type'] = 'Daily';
            this.showViewType = true;
            this.showViewAllType = true;
            this.filterData['followup_id'] = '3';
        }
        else if (this.params['tabParams'] == 'storeDailyFollowUpReport'
        ) {
            this.viewTypeList = ['Daily', 'Weekly', 'New Calls', 'Current Total Calls', 'Followup History'];
            this.filterData['view_type'] = 'Daily';
            this.showViewType = true;
            this.showViewAllType = true;
            this.filterData['followup_id'] = '8';
        }
        else if (this.params['tabParams'] == 'callsReport'
        ) {
            this.viewTypeList = ['Incoming Calls', 'Outgoing Calls'];
            this.filterData['view_type'] = 'Incoming Calls';
            this.showViewType = true;
            // this.filterData['followup_id'] = '7';
        } else if (this.params['tabParams'] == 'machineSerialHistory' || this.params['tabParams'] == 'agewisestockreport') {
            this.searchPlaceHolder = "Serial No";
        } else if (this.params['tabParams'] == 'srfPendingReport') {
            this.searchPlaceHolder = "Search Client ID/Name ...";
            this.showSrfNo = true;
            this.showStatus = true;
            this.showColumnFilter = true; // Enable column filter for srfPendingReport

            // Define SRF-specific status list
            this.statusList = [
                { status_value: 'Send To Company', name: 'Send To Company' },
                { status_value: 'Estimation From Company', name: 'Estimation From Company' },
                { status_value: 'Estimation To Client', name: 'Estimation To Client' },
                { status_value: 'Approval From Client', name: 'Approval From Client' },
                { status_value: 'Approval To Company', name: 'Approval To Company' },
                { status_value: 'Courier Details', name: 'Courier Details' },
                { status_value: 'Receive From Company', name: 'Receive From Company' },
                { status_value: 'Informed Delivery To Client', name: 'Informed Delivery To Client' },
                { status_value: 'Delivery', name: 'Delivery' }
            ];
        } else if (this.params['tabParams'] == 'couponPointsReport') {
            this.searchPlaceHolder = "Search Client ID/Name...";
            this.showFromDate = false;
            this.showToDate = false;
            // The following lines were part of the original couponPointsReport block
            // and are retained here as they were not explicitly removed by the instruction.
            this.showViewType = false;
            this.showUserViewType = false;
            this.showDateFilter = false;
            this.showViewAllType = false;
            this.showhvType = false;
            this.showReferenceType = false;
            this.showNo = false;
            this.showha = false;
            this.showFromDate = false;
            this.showToDate = false;
            this.showBranch = false;
            this.showGroup = false;
            this.showStatus = false;
            this.showServiceNo = false;
            this.showSrfNo = false;
            this.showServiceView = false;
            this.showTestingStatus = false;
            this.showdistrict = false;
            this.showType = false;
            this.showReportType = false;
            this.showEmployeeFilter = false;
            this.showChallanOutno = false;
            this.showWarranty = false;
        } else if (this.params['tabParams'] == 'couponCodeReport') {
            this.searchPlaceHolder = "Search Client ID / Name / Mobile...";
            this.showNo = false;
            this.showha = false;
            this.showhvType = false;
            this.showReferenceType = false;
            this.showServiceView = false;
            this.showViewType = false;
        } else if (this.params['tabParams'] == 'campPromoReport') {
            this.searchPlaceHolder = "Search Client ID / Name / Mobile";
            this.viewTypeList = ['Daily', 'Weekly', 'New Calls', 'Current Total Calls','Followup History'];
            this.filterData['view_type'] = 'Daily';
            this.showViewType = true;
            this.showUserViewType = false;
            this.showDateFilter = true;
            this.showViewAllType = false;
            this.showhvType = false;
            this.showReferenceType = false;
            this.showNo = false;
            this.showha = false;
            this.showFromDate = true;
            this.showToDate = true;
            this.showBranch = false;
            this.showGroup = false;
            this.showStatus = false;
            this.showServiceNo = false;
            this.showSrfNo = false;
            this.showServiceView = false;
            this.showTestingStatus = false;
            this.showdistrict = false;
            this.showType = false;
            this.showReportType = false;
            this.showEmployeeFilter = false;
            this.showChallanOutno = false;
            this.showWarranty = false;
            // Show: search, from_date, to_date, branch
            this.showSearch = true;
            this.showFromDate = true;
            this.showToDate = true;
            this.showBranch = true;
        } else if (this.params['tabParams'] == 'recheckupReport') {
            this.searchPlaceHolder = "Search Client ID/Name...";
            this.showSearch = true;
            this.showFromDate = true;
            this.showToDate = true;
            this.showBranch = true;
            this.showViewType = false;
            this.showhvType = false;
            this.showReferenceType = false;
            this.showNo = false;
        }

        if (this.params['tabParams'] == 'salesDailyFollowUpReport'
            || this.params['tabParams'] == 'dummysalesDailyFollowUpReport') {
            this.typeview = ['Sales+Fb', 'Sales', 'Fb'];
            this.filterData['ref_type'] = 'Sales+Fb';
            this.showType = true;
        }
        if (this.params['tabParams'] == 'hvDailyFollowUpReport') {
            this.typeview = ['Hv+Fb', 'Hv', 'Fb'];
            this.filterData['ref_type'] = 'Hv+Fb';
            this.showType = true;
        }
        if (this.params['tabParams'] == 'soaDailyFollowUpReport') {
            this.filterData['followup_id'] = '2';
        }
        if (this.params['tabParams'] == 'soldDailyFollowUpReport') {
            this.filterData['followup_id'] = '4';
        }
        if (this.params['tabParams'] == 'dummysalesDailyFollowUpReport') {
            this.filterData['followup_id'] = '9';
        }
        if (this.params['tabParams'] == 'promounsoldDailyFollowUpReport') {
            this.filterData['followup_id'] = '35';
        } else if (this.params['tabParams'] == 'monthWiseSold' || this.params['tabParams'] == 'branchWiseSold') {
            this.viewTypeList = ['Detail', 'Summary'];
            this.filterData['view_type'] = 'Detail';
        } else if (this.params['tabParams'] == 'notWillingNowDailyFollowUpReport'
            || this.params['tabParams'] == 'notWillingNowNextFollowUpReport'
            || this.params['tabParams'] == 'notWillingNowHisFollowUpReport') {
            that.viewTypeList = [];
            this.filterData['view_type'] = '';
            this.store.select(fromCommonStore.getAllFollowUpStatus).subscribe((res: any) => {
                if (_.isEmpty(res.data)) {
                    return;
                }
                _.filter(res.data, function (obj) {
                    if (obj['is_followup'] == 'Yes' && obj['NotWillingNow'] == 'Yes') {
                        that.viewTypeList.push(obj['name']);
                        if (that.viewTypeList.length) {
                            that.filterData['view_type'] = obj['name'];
                        }
                    }
                    return true;
                });
            });
        }

        that.subscribeAuth = that.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                that.usertype = auth['usertype'];
                that.canExportPrint = (auth['usertype'] == 'Super_Admin' || auth['usertype'] == 'Admin');
                if (auth['usertype'] != 'Super_Admin' && auth['usertype'] != 'Admin' && auth['usertype'] != 'Accounts') {
                    that.filterData['branch_id'] = auth['branch_id'];
                    //that.showUserViewType = false;
                    that.branchCtrl.disable();
                } else if ((auth['usertype'] == 'Super_Admin' || auth['usertype'] == 'Admin' || auth['usertype'] == 'Accounts') &&
                    (that.params['tabParams'] == 'salesDailyFollowUpReport'
                        || that.params['tabParams'] == 'dummysalesDailyFollowUpReport'
                        || that.params['tabParams'] == 'promounsoldDailyFollowUpReport'
                        || that.params['tabParams'] == 'soaDailyFollowUpReport'
                        || that.params['tabParams'] == 'soldDailyFollowUpReport'
                        || that.params['tabParams'] == 'hvDailyFollowUpReport'
                        || that.params['tabParams'] == 'aftersalesDailyFollowUpReport'
                        || that.params['tabParams'] == 'unsoldDailyFollowUpReport'
                        || that.params['tabParams'] == 'OldClientDailyFollowUpReport'
                        || that.params['tabParams'] == 'purchaseAgainstSrfReport'
                        || that.params['tabParams'] == 'storeDailyFollowUpReport')) {
                    if (that.params['tabParams'] == 'purchaseAgainstSrfReport' || that.params['tabParams'] == 'srfEstimationAgainstBillAmt') {
                        that.filterData['branch_id'] = auth['branch_id'];
                    }
                    that.showUserViewType = true;
                }
                that.getReports();
            }
        });
        function hasValidDistrict(input: FormControl) {
            let branchID = input.value, retVal = null;
            if (branchID && typeof branchID === "string") {
                let item = _.find(this.districtlist, { 'districts_name': branchID });
                if (item == undefined) {
                    retVal = { inValidDistrict: true };
                }
                //retVal = { inValidDistrict: true };
            }
            return retVal;
        }

        function hasValidUser(input: FormControl) {
            let branchID = input.value, retVal = null;
            if (branchID && typeof branchID === "string") {
                let item = _.find(this.userlist, { 'userid': branchID });
                if (item == undefined) {
                    retVal = { inValidUser: true };
                }
                //retVal = { inValidDistrict: true };
            }
            return retVal;
        }

        // function hasValidWarranty(input: FormControl){
        //     if(input.value && input.value == ""){
        //         return '';
        //     }else{
        //         let warrOk = this.warranty.includes(input.value);
        //         return warrOk;
        //     }
        // }
        // this.warrantyTypeCtrl = new FormControl('',[
        //     Validators.required,
        //     hasValidWarranty.bind(this)
        // ]);

        this.districtCtrl = new FormControl('', [
            Validators.required,
            hasValidDistrict.bind(this)
        ]);


        this.userCtrl = new FormControl('', [
            Validators.required,
            hasValidUser.bind(this)
        ]);

        //this.districtCtrl = new FormControl();
        this.filteredDistrict = this.districtCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterDistrict(name) : this.districtlist.slice());
        this.getDistricts();

        this.filteredUser = this.userCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterUser(name) : this.userlist.slice());
        this.getUser();
    }
    getDistricts() {
        let that = this;
        this.commonService
            .getDistrictList()
            .then(function (res: any) {
                if (res.success) {
                    that.districtlist = res.data;
                }
            });
    }
    filterDistrict(name: string) {
        name = _.escapeRegExp(name);
        return this.districtlist.filter(item => (new RegExp(name, 'gi').test(item.districts_name)));
    }

    getUser() {
        let that = this;
        let followup_id = that.filterData['followup_id'];
        if (!_.isEmpty(followup_id)) {
            let data = {
                fol_id: followup_id
            };
            this.commonService
                .getUserList(data)
                .then(function (res: any) {
                    if (res.success) {
                        that.userlist = res.data;
                        that.filterData['userid'] = res.data[0].userid;
                    }
                    this.getReports();
                });
        }

        // Add document click listener to close dropdowns
        document.addEventListener('click', (event: any) => {
            if (!event.target.closest('.column-header-with-filter')) {
                this.closeAllDropdowns();
            }
        });
    }

    ngAfterViewInit(): void {
        // Ensure header templates are applied after view initialization for ALL reports
        console.log('ngAfterViewInit: Report detected:', this.params['tabParams']);

        // Try multiple times to ensure templates get applied for ALL reports
        setTimeout(() => {
            console.log('ngAfterViewInit: First attempt to apply templates for', this.params['tabParams']);
            this.addHeaderTemplatesToColumns();
        }, 200);

        setTimeout(() => {
            console.log('ngAfterViewInit: Second attempt to apply templates for', this.params['tabParams']);
            this.addHeaderTemplatesToColumns();
        }, 500);

        setTimeout(() => {
            console.log('ngAfterViewInit: Third attempt to apply templates for', this.params['tabParams']);
            this.addHeaderTemplatesToColumns();
        }, 1000);
    }

    filterUser(name: string) {
        name = _.escapeRegExp(name);
        return this.userlist.filter(item => (new RegExp(name, 'gi').test(item.fullname)));
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        //this.subscribeService.publishReloadClientWalkInGrid().unsubscribe();
        if (!_.isEmpty(this.subscribeAuth)) {
            this.subscribeAuth.unsubscribe();
        }
        if (!_.isEmpty(this.subscribeBranch)) {
            this.subscribeBranch.unsubscribe();
        }
    }
    setPrintConfig() {
        this.printConfig = {
            title: _.upperCase(this['title']),
            columns: this.columns,
            rows: this.gloRepDataArr
        }
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.onChangePage({ page: 1 });
    }
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        //const viewHeight = this.el.nativeElement.getBoundingClientRect().height;
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getReports();
        }

    }

    filterItems(name: string) {
        name = _.escapeRegExp(name);
        return this.itemList.filter(item => (new RegExp(name, 'gi').test(item.client_code) || new RegExp(name, 'gi').test(item.name)));
    }

    displayRef(item_id: number) {
        if (item_id && this.itemList.length > 0) {
            let fitem = _.find(this.itemList, { 'ref_id': item_id });
            return fitem['name'];
        }
        return '';
    }
    //FOR STATUS COMBO 
    filterStatus(name: string) {
        name = _.escapeRegExp(name);
        return this.statusList.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }
    displayOctTypeFn(id: number) {
        if (id && this.octTypeList.length > 0) {
            let fitem = _.find(this.octTypeList, { 'id': id });
            return fitem ? fitem['name'] : '';
        }
        return '';
    }
    filterDoctorRef(val: any) {
        if (!val || typeof val === 'number') {
            this.filteredDoctorRef = this.doctorRefList;
            return;
        }
        const name = _.escapeRegExp(val);
        this.filteredDoctorRef = this.doctorRefList.filter(item => new RegExp(name, 'gi').test(item.name));
    }
    displayDoctorRefFn(item_id: number) {
        if (item_id && this.doctorRefList.length > 0) {
            let fitem = _.find(this.doctorRefList, { 'ref_id': item_id });
            return fitem ? fitem['name'] : '';
        }
        return '';
    }
    displayDocLedgerBillTypeFn(id: string) {
        if (id !== undefined && id !== '' && this.docLedgerBillTypeList.length > 0) {
            let fitem = _.find(this.docLedgerBillTypeList, { 'id': id });
            return fitem ? fitem['name'] : '';
        }
        return '';
    }
    displayStatusFn(fol_id: number) {
        if (fol_id && this.statusList.length > 0) {
            let fitem = _.find(this.statusList, { 'fol_id': fol_id });
            return fitem['name'];
        }
        return '';
    }
    // FOR SRF STATUS COMBO
    displaySrfStatusFn(status_value: string) {
        if (status_value && this.statusList.length > 0) {
            let fitem = _.find(this.statusList, { 'status_value': status_value });
            return fitem ? fitem['name'] : status_value;
        }
        return '';
    }
    displayDistrict(districtname) {
        let that = this;
        return districtname;
    }
    displayUser(userid) {
        if (this.userlist != undefined) {
            if (userid && this.userlist.length > 0) {
                let fitem = _.find(this.userlist, { 'userid': userid });
                return fitem['fullname'];
            }
        }
        return '';
    }

    // displayWarranty(warrType){
    //     let warrOk = this.warranty.include(warrType);
    //     return warrOk;
    // }
    //FOR TESTING COMBO 
    filterTestStatus(name: string) {
        name = _.escapeRegExp(name);
        return this.testStatusList.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }
    displayTestStatusFn(test_id: number) {
        if (test_id && this.testStatusList.length > 0) {
            let fitem = _.find(this.testStatusList, { 'id': test_id });
            return fitem['name'];
        } /*else if(!_.isEmpty(test_id)){
            let fitem = _.find(this.testStatusList, { 'id': test_id });
            return fitem['name'];
        }*/
        return '';
    }
    onScroll(offsetY) {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100);
    }
    //Date field reset function
    onDateChange(filterData: any) {
        if (this.filterData['dateStatus'] == true) {
            this.filterData['from_date'] = null;
            this.filterData['to_date'] = null;
            this.filterData['entry_from_date'] = null;
            this.filterData['entry_to_date'] = null;
        }
        else {
            this.filterData['from_date'] = new Date;
            this.filterData['to_date'] = new Date;
            // Keep entry dates empty even when "WithOut Date" is unchecked
            this.filterData['entry_from_date'] = null;
            this.filterData['entry_to_date'] = null;
        }
    }
    //ON CHANGE PAGINATION NUMBER 
    onChangePage(event) {
        let limit = this.page.limit - 1,
            pageNo = event.page,
            start = limit * (pageNo - 1),
            end = limit * (pageNo);
        this.reportData = [];
        // Use filtered data if available, otherwise use original data
        const sourceData = this.filteredDataArray.length > 0 ? this.filteredDataArray : this.gloRepDataArr;
        let data = sourceData.slice(start, end);
        if (this.params['tabParams'] === 'overallSalesReport') {
            data.forEach(obj => {
                // obj.gross_total = obj.gross_total.toLocaleString('en-IN');
                // obj.discount_amount = obj.discount_amount.toLocaleString('en-IN');
                // obj.less_amount = obj.less_amount.toLocaleString('en-IN');
                // obj.amount = obj.amount.toLocaleString('en-IN');
                // obj.cgst_amount = obj.cgst_amount.toLocaleString('en-IN');
                // obj.sgst_amount = obj.sgst_amount.toLocaleString('en-IN');
                let colNameArr = ['gross_total', 'discount_amount', 'less_amount', 'amount', 'cgst_amount', 'sgst_amount'];
                colNameArr.forEach(col => {
                    if (obj[col]) {
                        obj[col] = obj[col].toLocaleString('en-IN');
                    }
                });
            });
        }
        this.reportData = data;
        this.footerRow(this.columns, false); // TO CHECK FOOTER
        document.getElementsByClassName('datatable-body')[0].scrollTop = 0; // TO KEEP SCROLL BACK TO TOP
        // if (data.length < 13) {
        //     $('.grid-foot-total-row').ready(function () {
        //         $('.grid-foot-total-row').addClass('ext-bottom');
        //     });
        // }
    }
    ontype() {
        if (this.filterData['view_type'] == 'Sales') {
            this.typeview = ['Sales+Fb', 'Sales', 'Fb'];
            this.filterData['ref_type'] = 'Sales+Fb';
        } else if (this.filterData['view_type'] == 'HV') {
            this.typeview = ['Hv+Fb', 'Hv', 'Fb'];
            this.filterData['ref_type'] = 'Hv+Fb';
        } else if (this.filterData['view_type'] == 'OLD CLIENT' || this.filterData['view_type'] == 'Not Willing Now') {
            this.filterData['ref_type'] = 'Sales+Fb';
        }
        else if (this.filterData['view_type'] == 'Dummy Sales') {
            this.typeview = ['Sales+Fb', 'Sales', 'Fb'];
            this.filterData['ref_type'] = 'Sales+Fb';
        }
    }
    onOpenedFilter(): void {
        setTimeout(function () {
            $('#filterSearch').focus();
        }, 100);
    }
    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }
    applyFilter() {
        this.filterPanel.close();

        if (!this.warranty.includes(this.filterData['warranty_type']) == (this.params['tabParams'] == 'notSatisfiedToSatisfiedReport')) {
            swal('ERROR', "Please, Select correct warranty Type", 'error');
            return '';
        }
        this.getReports();
    }
    clearFilter(): void {
        this.filterData = {
            "from_date": new Date(),
            "to_date": new Date(),
            "entry_from_date": null,
            "entry_to_date": null,
            "view_type": 'Daily',
            //"group_by": 'Client'
        };
        this.applyFilter();
    }
    onClickPrintBtn(): void {
        let that = this;
        setTimeout(function () {
            that.filterPanel.close();
        }, 10);
    }
    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }
    displayFn(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                return fitem['branch_name'];
            }
        }
        return '';
    }
    getReports(): void {
        let that = this;

        // For notification report, map selected fullname to userid
        let mappedUserId = this.filterData['userid'];
        if (this.params['tabParams'] === 'notificationReport' && this.filterData['view_type']) {
            const selectedName = this.filterData['view_type'];
            if (this.userListMap[selectedName] !== undefined) {
                mappedUserId = this.userListMap[selectedName];
            }
        }

        that.searchParams = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            search_name: this.filterData['search_name'],
            lesser: this.filterData['lesser'],
            greater: this.filterData['greater'],
            // dateStatus: this.filterData['dateStatus'],
            // from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            // to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
            warranty_type: this.filterData['warranty_type'],
            page_type: this.params['tabParams'] === 'campPromoReport' ? 'campPromoDailyFollowUpReport' : this.params['tabParams'],
            view_type: this.filterData['view_type'],
            hv_type: this.filterData['hv_type'],
            reference_type: this.filterData['ref_id'],
            user_id: mappedUserId,
            branch_id: this.filterData['branch_id'],
            test_id: this.filterData['test_id'],
            fol_id: this.filterData['fol_id'],
            hamodel: this.filterData['hamodel'],
            spare: this.filterData['Spare'],
            type: this.filterData['type'],
            serviceno: this.filterData['serviceno'] || '',
            view: this.filterData['view'] || '',
            srfno: this.filterData['srfno'],
            srf_status: this.filterData['srf_status'],
            all: this.filterData['all'],
            group: this.filterData['group'],
            service_filter: this.filterData['service_filter'],
            ref_type: this.filterData['ref_type'],
            district: this.filterData['districts'],
            report_type: this.filterData['report_type'],
            empid: this.filterData['empid'],
            challan_out_no: this.filterData['challan_out_no'],
            delivery_status: this.filterData['delivery_status'],
            warranty: this.filterData['warranty_type'],
            promo_name: this.filterData['promo_name'] || '',
            fol_type: this.filterData['fol_type'] || '',
            oct_type_id: this.filterData['oct_type_id'] || '',
            bill_type_filter: this.filterData['bill_type_filter'] || '',
        };
        that.searchParams.from_date = (!this.filterData['from_date']) ? '' : moment(this.filterData['from_date']).format('YYYY-MM-DD');
        that.searchParams.to_date = (!this.filterData['to_date']) ? '' : moment(this.filterData['to_date']).format('YYYY-MM-DD');
        that.searchParams.entry_from_date = (!this.filterData['entry_from_date']) ? '' : moment(this.filterData['entry_from_date']).format('YYYY-MM-DD');
        that.searchParams.entry_to_date = (!this.filterData['entry_to_date']) ? '' : moment(this.filterData['entry_to_date']).format('YYYY-MM-DD');
        that.page.count = 0;
        //that.reportData = [];
        that.columns = [];
        that.toggleCol = [];

        // Handle special reports separately
        if (that.params['tabParams'] == 'recheckupReport') {
            const recheckupParams = {
                from_date: moment(that.filterData['from_date']).format('YYYY-MM-DD'),
                to_date: moment(that.filterData['to_date']).format('YYYY-MM-DD'),
                branch_id: that.filterData['branch_id'] || '',
                search: that.filterData['search_name'] || ''
            };

            that.isLoadMask = that.reportsService.getRecheckupReport(recheckupParams)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    that.reportData = res.data;
                    that.gloRepDataArr = res.data;
                    that.page.count = res.totCnt;
                    that.columns = res.columns;
                    that.toggleCol = res.columns;
                    that.printConfig['columns'] = res.columns;
                    that.printConfig['rows'] = res.data;
                    that.checkCustomTemp();
                    that.onChangePage({ page: 1 });
                });
        } else if (that.params['tabParams'] == 'clientHistoryReport') {
            const clientHistoryParams = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderDir: `${this.page.orderDir}`,
                from_date: that.filterData['from_date'] ? moment(that.filterData['from_date']).format('YYYY-MM-DD') : '',
                to_date: that.filterData['to_date'] ? moment(that.filterData['to_date']).format('YYYY-MM-DD') : '',
                search_data: that.filterData['search_name'] || '',
                branch_id: that.filterData['branch_id'] || '',
                reference_id: that.filterData['reference_type'] || '',
                dateStatus: that.filterData['dateStatus'] || ''
            };

            that.isLoadMask = that.reportsService.getClientHistoryReport(clientHistoryParams)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    that.reportData = res.data;
                    that.gloRepDataArr = res.data;
                    that.page.count = res.totCnt;
                    that.columns = res.columns;
                    that.toggleCol = res.columns;
                    that.printConfig['columns'] = res.columns;
                    that.printConfig['rows'] = res.data;
                    that.checkCustomTemp();
                    that.onChangePage({ page: 1 });
                });
        } else if (that.params['tabParams'] == 'rocReferralReport') {
            that.isLoadMask = that.reportsService.getReports(that.searchParams)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    that.page.count = res.totCnt;
                    that.usertype = res.usertype;
                    that.gloRepDataArr = res.data;
                    that.columns = res.columns;
                    that.toggleCol = res.columns;
                    that.printConfig['columns'] = res.columns;
                    that.printConfig['rows'] = res.data;
                    that.checkCustomTemp();
                    that.onChangePage({ page: 1 });
                });
        } else if (that.params['tabParams'] == 'notWillingNowReport') {
            that.isLoadMask = that.reportsService.getReports(that.searchParams)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    that.page.count = res.totCnt;
                    that.usertype = res.usertype;
                    that.gloRepDataArr = res.data;
                    that.columns = res.columns;
                    that.toggleCol = res.columns;
                    that.printConfig['columns'] = res.columns;
                    that.printConfig['rows'] = res.data;
                    that.checkCustomTemp();
                    that.onChangePage({ page: 1 });
                });
        } else if (that.params['tabParams'] == 'docLedgerReport') {
            that.isLoadMask = that.reportsService.getReports(that.searchParams)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    that.page.count = res.totCnt;
                    that.usertype = res.usertype;
                    that.gloRepDataArr = res.data;
                    that.columns = res.columns;
                    that.toggleCol = res.columns;
                    that.printConfig['columns'] = res.columns;
                    that.printConfig['rows'] = res.data;
                    that.checkCustomTemp();
                    that.onChangePage({ page: 1 });
                });
        } else if (that.params['tabParams'] == 'docTestingLedgerReport') {
            that.isLoadMask = that.reportsService.getReports(that.searchParams)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    that.page.count = res.totCnt;
                    that.usertype = res.usertype;
                    that.gloRepDataArr = res.data;
                    that.columns = res.columns;
                    that.toggleCol = res.columns;
                    that.printConfig['columns'] = res.columns;
                    that.printConfig['rows'] = res.data;
                    that.checkCustomTemp();
                    that.onChangePage({ page: 1 });
                });
        } else if (that.params['tabParams'] == 'referralReport') {
            const referralParams = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderDir: `${this.page.orderDir}`,
                from_date: that.filterData['from_date'] ? moment(that.filterData['from_date']).format('YYYY-MM-DD') : '',
                to_date: that.filterData['to_date'] ? moment(that.filterData['to_date']).format('YYYY-MM-DD') : '',
                search_data: that.filterData['search_name'] || '',
                branch_id: that.filterData['branch_id'] || '',
                reference_id: that.filterData['reference_type'] || '',
                dateStatus: that.filterData['dateStatus'] || ''
            };

            that.isLoadMask = that.reportsService.getReferralReport(referralParams)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    that.reportData = res.data;
                    that.gloRepDataArr = res.data;
                    that.page.count = res.totCnt;
                    that.columns = res.columns;
                    that.toggleCol = res.columns;
                    that.printConfig['columns'] = res.columns;
                    that.printConfig['rows'] = res.data;
                    that.checkCustomTemp();
                    that.onChangePage({ page: 1 });
                });
        } else {
            that.isLoadMask = that.reportsService.getReports(that.searchParams)
                .then(function (res: any) {
                    //TO REMOVE FOOTER CLASS
                    //$('.datatable-body-row').removeClass('grid-foot-total-row');
                    that.loadingIndicator = false;
                    if (res.totCnt > 0 && res.totCnt <= that.page.limit) {
                        res.totCnt += 1;
                    }
                    that.page.count = res.totCnt;
                    that.usertype = res.usertype;
                    //that.reportData = res.data;
                    that.gloRepDataArr = res.data;
                    // Handle dynamic column selection for srfPendingReport
                    if (that.params['tabParams'] == 'srfPendingReport') {
                        that.setupDynamicColumns(res.columns);
                    } else {
                        that.columns = res.columns;
                        that.toggleCol = Object.assign({}, res.columns);
                    }

                    // Apply filter templates immediately for ALL reports
                    console.log('Columns received for report:', that.params['tabParams'], ', applying templates immediately');
                    setTimeout(() => {
                        that.addHeaderTemplatesToColumns();
                    }, 50);

                    that.printConfig['columns'] = that.columns;
                    that.printConfig['rows'] = res.data;
                    that.footerRow(res.columns, true);
                    that.checkCustomTemp();
                    // Initialize inline column filters for ALL reports
                    that.initializeColumnFilters();

                    // Apply header templates for ALL reports after data is loaded
                    setTimeout(() => {
                        that.addHeaderTemplatesToColumns();
                    }, 300);

                    that.onChangePage({ page: 1 });

                    if (that.params['tabParams'] == "serviceTrackingReport" && that.filterData['view'] == "Count View") {
                        that.serviceFilterList = ['Estimation From Company', 'Estimation From HeadOffice', 'Estimation To Client', 'Approval From Client', 'Approval To Company', 'Approval To HeadOffice', 'Informed Delivery To Client', 'Delivery Pending', 'SRF Closed by Head Office'];
                    } else {
                        that.serviceFilterList = ['Delivery Pending'];
                    }
                });
        }
    }

    // Dynamic column selection methods for srfPendingReport
    setupDynamicColumns(allColumns: any[]) {
        this.allAvailableColumns = allColumns.map((col, index) => ({
            ...col,
            selected: this.getDefaultSelection(col.prop, index),
            original_index: index
        }));

        this.showColumnFilter = true;
        this.updateSelectedColumns();
    }

    getDefaultSelection(columnProp: string, index: number): boolean {
        // Define default selected columns for srfPendingReport
        const defaultColumns = [
            'booking_date', 'srf_no', 'employee_name', 'branch_name',
            'client_id', 'client_name', 'machine_details', 'delivery_status', 'delivery_date'
        ];

        // Select specified default columns
        return defaultColumns.includes(columnProp);
    }

    updateSelectedColumns() {
        this.selectedColumns = this.allAvailableColumns
            .filter(col => col.selected)
            .sort((a, b) => a.original_index - b.original_index);

        // Update selectedColumnProps for multi-select binding
        this.selectedColumnProps = this.selectedColumns.map(col => col.prop);

        // Update the displayed columns
        this.columns = this.selectedColumns;
        this.toggleCol = this.selectedColumns;
    }

    onColumnSelectionChange() {
        // Update selected status based on selectedColumnProps
        this.allAvailableColumns.forEach(col => {
            col.selected = this.selectedColumnProps.includes(col.prop);
        });

        this.updateSelectedColumns();

        // Force complete table refresh
        this.loadingIndicator = true;
        setTimeout(() => {
            this.columns = [...this.selectedColumns];
            this.toggleCol = [...this.selectedColumns];
            this.checkCustomTemp();
            this.loadingIndicator = false;
        }, 10);
    }

    toggleColumn(columnProp: string, selected: boolean) {
        const column = this.allAvailableColumns.find(col => col.prop === columnProp);
        if (column) {
            column.selected = selected;
            this.updateSelectedColumns();
        }
    }


    footerRow(columns: any, initialCall: boolean) {
        let that = this,
            footArr = [];
        footArr["footRow"] = true;
        this.showSumFooter = false;
        if (initialCall == true) {
            that.footerDataObj = [];
            for (let i = 0; i < columns.length; i++) {
                let propName = columns[i].prop
                if (columns[i].summary == 'sum') {
                    let tot_sum = 0;
                    //let col = columns[i].name;

                    _.forEachRight(that.gloRepDataArr, function (value) {
                        tot_sum += value[propName] ? value[propName] : 0;
                    });
                    if (tot_sum > 0) {
                        this.showSumFooter = true;
                        footArr[propName] = tot_sum;
                    }
                } else if (columns[i].summaryDisplay) {
                    footArr[propName] = columns[i].summaryDisplay;
                    this.showSumFooter = true;
                }
            }
            if (this.showSumFooter == true) {
                //that.reportData.push(footArr);
                //that.page.limit += 1;
                that.footerDataObj = footArr;
            }
        } else {
            if (that.footerDataObj['footRow'] == true) {
                if (this.params['tabParams'] === 'overallSalesReport') {
                    let colNameArr = ['gross_total', 'discount_amount', 'less_amount', 'amount', 'cgst_amount', 'sgst_amount'];
                    colNameArr.forEach(col => {
                        if (that.footerDataObj[col]) {
                            that.footerDataObj[col] = that.footerDataObj[col].toLocaleString('en-IN');
                        }
                    });
                }
                that.reportData.push(that.footerDataObj);
            }
        }
        //this.showSumFooter = false;
    }
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"

    }
    /**
    * TO CHANGE SPECIFIC ROW COLOR
    */
    getRowClass(row) {
        return {
            'grid-foot-total-row': row.footRow == true
        };
    }
    onClickExcelBtn() {
        setTimeout(function () {
            that.filterPanel.close();
        }, 10);
        const columns = this.columns.filter(obj => !obj.cellTemplateName).map(obj => ({ name: obj.name, prop: obj.prop, width: obj.width }));
        let that = this;
        let data;
        if (this.title != 'All Branch DSR Report') {
            data = {
                columns: JSON.stringify(columns),
                data: JSON.stringify(this.gloRepDataArr),
                title: this.title
            };
        }
        else if (this.title == 'All Branch DSR Report') {
            if (this.filterData['branch_id']) {
                let branchObj = _.filter(this.branchList, { 'branch_id': this.filterData['branch_id'] });

                data = {
                    columns: JSON.stringify(columns),
                    data: JSON.stringify(this.gloRepDataArr),
                    title: this.title,
                    branch_id: branchObj[0].chk_name
                };
            }
            else {
                data = {
                    columns: JSON.stringify(columns),
                    data: JSON.stringify(this.gloRepDataArr),
                    title: this.title
                };
            }

        }
        else if (this.title == 'OCT Report') {
            if (this.filterData['branch_id']) {
                let branchObj = _.filter(this.branchList, { 'branch_id': this.filterData['branch_id'] });
                data = {
                    columns: JSON.stringify(columns),
                    data: JSON.stringify(this.gloRepDataArr),
                    title: this.title,
                    branch_id: branchObj.length > 0 ? branchObj[0].chk_name : ''
                };
            } else {
                data = {
                    columns: JSON.stringify(columns),
                    data: JSON.stringify(this.gloRepDataArr),
                    title: this.title
                };
            }
        }


        this.isLoadMask = this.commonService
            .printing(data)
            .then(function (res: any) {
                if (res['_body']) {
                    var headers = res['headers']["_headers"],
                        //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
                        ctype = headers.get('content-type')[0],
                        cdispos = headers.get('content-disposition')[0],//'attachment;filename="New_Title_Report_As_On_14_11_2017.xlsx"',
                        filename = cdispos.replace(/attachment;filename=|"/gi, ''),
                        blob = new Blob([res['_body']], {
                            type: ctype
                        }),
                        //blob = new Blob([res['_body']], { type: ctype }),
                        link = document.createElement('a');

                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    link.click();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
    //CUSTOM TEMPLATE 
    checkCustomTemp() {
        for (let i = 0; i < this.columns.length; i++) {
            let tempName = this.columns[i].cellTemplateName;
            if (tempName == 'printTemplate') {
                this.columns[i]['cellTemplate'] = this.printTemplate;
            } else if (tempName == 'optionTemplate') {
                this.columns[i]['cellTemplate'] = this.optionTemplate;
            } else if (tempName == 'optionTrackTemplate') {
                this.columns[i]['cellTemplate'] = this.optionTrackTemplate;
            } else if (tempName == 'optionImageTemplate') {
                this.columns[i]['cellTemplate'] = this.optionImageTemplate;
            }
            else if (tempName == 'optionActionTemplate') {
                this.columns[i]['cellTemplate'] = this.optionActionTemplate;
            }
            else if (tempName == 'pointDetailsTemplate') {
                this.columns[i]['cellTemplate'] = this.pointDetailsTemplate;
            }
        }

        // Add header templates for ALL reports using standard styling
        setTimeout(() => {
            this.addHeaderTemplatesToColumns();
        }, 50);
    }

    //ON CLICK PRINT BUTTON
    onClickRowPrintBtn(type, rowObj) {
        this.hvPrintConfig = {
            type: type,
            clientDet: rowObj
        }
        setTimeout(() => {
            this.printPage.printPreview();
        }, 100);
    }
    bsModalRef: BsModalRef;
    viewHistory(row) {
        let data = {
            client_id: row.client_id,
            from_page: 'followUp',
        }
        /*         that=this;
                that.commonService
                    .getClientHistory(data)
                    .then(function (res: any) {
                        that.clientdata=res.data;
                    }); */
        this.bsModalRef = this.modalService.show(clientHistoryComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg maxWidthPer-50'
        });
        this.bsModalRef.content.showClientHistory = data;
    }
    viewtrackHistory(row) {
        let data = {
            ser_id: row.ser_id,
            view: 'Track View',
            bill_no: row.bill_no,
            client_id: row.client_id,
            srf_no: row.srf_no,
            client_branch_id: row.client_branch_id
        }
        /*         that=this;
                that.commonService
                    .getClientHistory(data)
                    .then(function (res: any) {
                        that.clientdata=res.data;
                    }); */
        this.bsModalRef = this.modalService.show(trackHistoryComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-xl'
        });
        this.bsModalRef.content.showTrackHistory = data;
    }
    @ViewChild('printPagerep') printPagerep;
    //printdata: any = this.reportData;
    onPrintReport(printdata) {
        let that = this;
        this.soaprintConfig = {
            type: "SOA",
            title: 'SOUNDS GOOD HEARING CARE',
            subTitle: 'SOA Details',
            rows: printdata,
            columns: ''
            /*  fromdate: that.datePipe.transform(that.filterData['from_date'], 'dd-MM-yyyy'),
             todate: that.datePipe.transform(that.filterData['date'], 'dd-MM-yyyy') */
        }
        setTimeout(() => {
            this.printPagerep.printPreview();
        }, 100);
        /*setTimeout(() => {
            that.filterPanel.close();
        }, 100);*/
    }

    onSelectReportType(reportType) {

        this.showFromDate = true;
        this.showToDate = true;

        if (this.params['tabParams'] == 'purchaseAgainstSrfReport') {
            if (reportType == 'Pending') {
                this.showFromDate = false;
                this.showToDate = false;
            }
        }


    }

    searchEmployee(query: string) {
        this.searchTermsEmp.next(query);
    }

    displayEmp(empID: number) {
        if (empID && this.empList.length > 0) {
            let femp = _.find(this.empList, { 'empid': empID });
            // this.salesbillentrydata['emp_name'] = femp.empname;
            return femp['empname'];
        } else {
            return '';
        }
    }

    showDataCheckWindow() {
        let data = {
            searchParams: this.searchParams,
            reportData: this.reportData,
            reportColumns: this.columns,
            title: this.title
        }
        this.bsModalRef = this.modalService.show(dataComparisonComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg compWidth-90'
        });
        this.bsModalRef.content.getPopUp = data;
    }

    onDeleteSrfHistory(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: '' + row.client_name + '',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function () {
            that.isLoadMask = that.reportsService
                .deleteSrfHistory(row.ser_id)
                .then(function (res: any) {
                    if (res.success) {
                        that.getReports();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }

                });
        }, function (dismiss) {

        });
    }

    // START - CR-20
    ser_img_array = [];
    ShowServiceImages(row, template: TemplateRef<any>) {
        this.ser_img_array = [];
        let that = this;
        let data = {
            ser_id: row.ser_id
        };

        this.reportsService
            .getServiceWalkInImageList(data)
            .then(function (res: any) {
                that.ser_img_array = res.data;
            });
        this.bsModalRef = this.modalService.show(template, {
            keyboard: false,
            ignoreBackdropClick: true
        });
    }

    closemodal() {
        this.ser_img_array = [];
        this.bsModalRef.hide();
    }
    onDeleteServiceImage(row) {
        let that = this;
        let data = {
            ser_img_id: row.ser_img_id
        };
        this.reportsService
            .deleteServiceWalkInImage(data)
            .then(function (res: any) {
                const index = that.ser_img_array.findIndex(item => item.ser_img_id === row.ser_img_id);
                that.ser_img_array.splice(index, 1);
            });
    }


    // Point Details Modal Methods
    openPointDetailsModal(row: any) {
        this.selectedClient = row;

        // Fetch point history
        this.reportsService.getClientPointsHistory({
            client_id: row.client_id
        }).then((res: any) => {
            if (res.success) {
                this.pointHistoryData = res.data;
                this.pointDetailsModalRef = this.modalService.show(
                    this.pointDetailsModal,
                    { class: 'modal-lg' }
                );
            } else {
                this.toasterService.pop('error', 'Error', 'Failed to fetch point history');
            }
        }).catch((error) => {
            console.error('Error fetching point history:', error);
            this.toasterService.pop('error', 'Error', 'Failed to fetch point history');
        });
    }

    closePointDetailsModal() {
        if (this.pointDetailsModalRef) {
            this.pointDetailsModalRef.hide();
            this.pointHistoryData = [];
            this.selectedClient = {};
        }
    }

    // END - CR-20

    // Inline Column Filter Methods
    initializeColumnFilters() {
        console.log('Initializing column filters for ALL reports. Current report:', this.params['tabParams']);

        // Initialize filter objects for ALL reports
        this.columnFilters = {};
        this.showDropdown = {};
        this.dropdownOptions = {};
        this.filteredOptions = {};
        this.currentFilterSearch = '';
        this.currentActiveFilter = null;

        // Add header templates to columns with delay to ensure ViewChild templates are available
        setTimeout(() => {
            this.addHeaderTemplatesToColumns();
        }, 100);
    }

    addHeaderTemplatesToColumns() {
        if (this.columns && this.columns.length > 0) {
            console.log('Adding dynamic filter template to ALL columns for report:', this.params['tabParams']);
            console.log('Available columns:', this.columns.map(col => ({ name: col.name, prop: col.prop })));
            console.log('Dynamic filter template available:', !!this.dynamicFilterTemplate);

            // Ensure dynamic template is available before applying
            if (this.dynamicFilterTemplate) {
                let templatesApplied = 0;

                // Apply dynamic filter template to ALL columns for ALL reports
                this.columns.forEach(column => {
                    // Skip columns that shouldn't have filters (like action columns)
                    if (!column.cellTemplateName ||
                        !column.cellTemplateName.includes('Template') ||
                        column.cellTemplateName === 'printTemplate') {
                        console.log('Applying dynamic filter template to:', column.name, 'with prop:', column.prop);
                        column['headerTemplate'] = this.dynamicFilterTemplate;
                        templatesApplied++;
                    } else {
                        console.log('Skipping filter for action column:', column.name);
                    }
                });

                console.log('Total templates applied to columns:', templatesApplied, 'in report:', this.params['tabParams']);

                // Force refresh of datatable to apply new templates
                if (this.reportTable) {
                    this.reportTable.recalculateColumns();
                    console.log('Datatable columns recalculated');
                }
            } else {
                console.log('Dynamic filter template not available yet');
            }
        }
    }

    // Dynamic dropdown toggle for any column
    toggleDynamicDropdown(columnProp: string, event: any) {
        event.stopPropagation();

        // Close all other dropdowns
        this.closeAllDropdowns();

        // Toggle the selected dropdown
        if (!this.showDropdown[columnProp]) {
            this.showDropdown[columnProp] = true;
            this.currentActiveFilter = columnProp;

            // Initialize dropdown options for this column if not already done
            if (!this.dropdownOptions[columnProp]) {
                this.initializeDropdownOptionsForColumn(columnProp);
            }

            // Position dropdown
            const rect = event.target.getBoundingClientRect();
            const dropdown = document.querySelector('.filter-dropdown-container') as HTMLElement;
            if (dropdown) {
                dropdown.style.top = (rect.bottom + 5) + 'px';
                dropdown.style.left = rect.left + 'px';
            }
        } else {
            this.showDropdown[columnProp] = false;
            this.currentActiveFilter = null;
        }
    }

    // Initialize dropdown options for any column dynamically
    initializeDropdownOptionsForColumn(columnProp: string) {
        if (this.gloRepDataArr && this.gloRepDataArr.length > 0) {
            // Extract unique values for this column
            const uniqueValues = Array.from(new Set(
                this.gloRepDataArr.map(item => item[columnProp])
                .filter(val => val !== null && val !== undefined && val !== '')
            ));

            this.dropdownOptions[columnProp] = uniqueValues.sort();
            this.filteredOptions[columnProp] = uniqueValues.slice();

            // Initialize all options as selected
            this.columnFilters[columnProp + 'Selected'] = {};
            uniqueValues.forEach(option => {
                this.columnFilters[columnProp + 'Selected'][option] = true;
            });

            console.log('Initialized dropdown options for', columnProp, ':', uniqueValues.length, 'unique values');
        }
    }

    filterDropdownOptions(filterType: string) {
        const searchTerm = this.currentFilterSearch.toLowerCase();
        this.columnFilters[filterType + 'Search'] = this.currentFilterSearch;
        if (this.dropdownOptions[filterType]) {
            this.filteredOptions[filterType] = this.dropdownOptions[filterType].filter(option =>
                option.toString().toLowerCase().includes(searchTerm)
            );
        }
    }

    // Helper methods for dynamic filtering
    isOptionSelected(filterType: string, option: any): boolean {
        return this.columnFilters[filterType + 'Selected'] &&
               this.columnFilters[filterType + 'Selected'][option] === true;
    }

    toggleOption(filterType: string, option: any, checked: boolean) {
        if (!this.columnFilters[filterType + 'Selected']) {
            this.columnFilters[filterType + 'Selected'] = {};
        }
        this.columnFilters[filterType + 'Selected'][option] = checked;
        this.applyDynamicColumnFilter(filterType);
    }

    isAllSelected(filterType: string): boolean {
        if (!this.dropdownOptions[filterType] || !this.columnFilters[filterType + 'Selected']) {
            return false;
        }
        return this.dropdownOptions[filterType].every(option =>
            this.columnFilters[filterType + 'Selected'][option] === true
        );
    }

    isIndeterminate(filterType: string): boolean {
        if (!this.dropdownOptions[filterType] || !this.columnFilters[filterType + 'Selected']) {
            return false;
        }
        const selected = this.dropdownOptions[filterType].filter(option =>
            this.columnFilters[filterType + 'Selected'][option] === true
        );
        return selected.length > 0 && selected.length < this.dropdownOptions[filterType].length;
    }

    selectAll(filterType: string, selectAll: boolean) {
        if (!this.columnFilters[filterType + 'Selected']) {
            this.columnFilters[filterType + 'Selected'] = {};
        }
        if (this.dropdownOptions[filterType]) {
            this.dropdownOptions[filterType].forEach(option => {
                this.columnFilters[filterType + 'Selected'][option] = selectAll;
            });
        }
        this.applyDynamicColumnFilter(filterType);
    }

    applyDynamicColumnFilter(filterType: string) {
        if (!this.gloRepDataArr) return;

        const selectedOptions = [];
        if (this.columnFilters[filterType + 'Selected']) {
            Object.keys(this.columnFilters[filterType + 'Selected']).forEach(option => {
                if (this.columnFilters[filterType + 'Selected'][option]) {
                    selectedOptions.push(option);
                }
            });
        }

        // Filter the data based on selected options
        if (selectedOptions.length === 0 || (this.dropdownOptions[filterType] && selectedOptions.length === this.dropdownOptions[filterType].length)) {
            // If nothing selected or everything selected, show all data
            this.reportData = this.gloRepDataArr.slice();
        } else {
            // Filter data to show only selected options
            this.reportData = this.gloRepDataArr.filter(item =>
                selectedOptions.includes(item[filterType])
            );
        }

        console.log('Applied filter for', filterType, ':', selectedOptions.length, 'selected options');
        console.log('Filtered data:', this.reportData.length, 'of', this.gloRepDataArr.length, 'records');
    }

    toggleSelectAll(filterType: string) {
        const selectAll = this.currentSelectAllState;
        this.columnFilters[filterType + 'SelectAll'] = selectAll;
        // Apply to all options, not just filtered ones, to maintain consistency
        this.dropdownOptions[filterType].forEach(option => {
            this.columnFilters[filterType + 'Selected'][option] = selectAll;
            this.currentSelectedOptions[option] = selectAll;
        });
        this.applyColumnFilter(this.getColumnProp(filterType));
    }

    getColumnProp(filterType: string): string {
        const propMap = {
            'branch': 'branch_name',
            'city': 'city',
            'status': 'status',
            'callBy': 'call_by'
        };
        return propMap[filterType] || filterType;
    }

    applyColumnFilter(columnProp?: string) {
        // Sync current selected options back to the main filter object
        if (this.currentActiveFilter) {
            Object.keys(this.currentSelectedOptions).forEach(option => {
                this.columnFilters[this.currentActiveFilter + 'Selected'][option] = this.currentSelectedOptions[option];
            });
        }

        // Update "Select All" checkbox states
        this.updateSelectAllStates();

        // Get all selected values for each filter
        const selectedBranches = Object.keys(this.columnFilters.branchSelected)
            .filter(key => this.columnFilters.branchSelected[key]);
        const selectedCities = Object.keys(this.columnFilters.citySelected)
            .filter(key => this.columnFilters.citySelected[key]);
        const selectedStatuses = Object.keys(this.columnFilters.statusSelected)
            .filter(key => this.columnFilters.statusSelected[key]);
        const selectedCallBy = Object.keys(this.columnFilters.callBySelected)
            .filter(key => this.columnFilters.callBySelected[key]);

        // Filter the complete dataset
        const filteredData = this.gloRepDataArr.filter(row => {
            const branchMatch = selectedBranches.length === 0 || selectedBranches.includes(row.branch_name);
            const cityMatch = selectedCities.length === 0 || selectedCities.includes(row.city);
            const statusMatch = selectedStatuses.length === 0 || selectedStatuses.includes(row.status);
            const callByMatch = selectedCallBy.length === 0 || selectedCallBy.includes(row.call_by);

            return branchMatch && cityMatch && statusMatch && callByMatch;
        });

        // Update pagination
        this.page.count = filteredData.length;
        this.page.offset = 0; // Reset to first page

        // Apply pagination to filtered data
        const start = 0;
        const end = Math.min(this.page.limit, filteredData.length);
        this.reportData = filteredData.slice(start, end);

        // Store filtered data for pagination
        this.filteredDataArray = filteredData;
    }

    updateSelectAllStates() {
        // Update branch select all state
        const allBranchesSelected = this.dropdownOptions.branch.every(option =>
            this.columnFilters.branchSelected[option]);
        this.columnFilters.branchSelectAll = allBranchesSelected;

        // Update city select all state
        const allCitiesSelected = this.dropdownOptions.city.every(option =>
            this.columnFilters.citySelected[option]);
        this.columnFilters.citySelectAll = allCitiesSelected;

        // Update status select all state
        const allStatusesSelected = this.dropdownOptions.status.every(option =>
            this.columnFilters.statusSelected[option]);
        this.columnFilters.statusSelectAll = allStatusesSelected;

        // Update callBy select all state
        const allCallBySelected = this.dropdownOptions.callBy.every(option =>
            this.columnFilters.callBySelected[option]);
        this.columnFilters.callBySelectAll = allCallBySelected;
    }

    toggleDropdown(filterType: string, event?: any) {
        // If clicking the same filter that's already open, close it
        if (this.currentActiveFilter === filterType) {
            this.currentActiveFilter = '';
            Object.keys(this.showDropdown).forEach(key => {
                this.showDropdown[key] = false;
            });
            return;
        }

        // Set current active filter
        this.currentActiveFilter = filterType;

        // Close all dropdowns first
        Object.keys(this.showDropdown).forEach(key => {
            this.showDropdown[key] = false;
        });

        // Open the clicked dropdown
        this.showDropdown[filterType] = true;

        // Set up current filter data
        this.setupCurrentFilterData(filterType);

        // Clear any pending hide timeouts
        if (this.hideDropdownTimeout) {
            clearTimeout(this.hideDropdownTimeout);
        }

        // Position the dropdown if opening
        if (event) {
            setTimeout(() => {
                this.positionDropdown(filterType, event);
            }, 10);
        }
    }

    positionDropdown(filterType: string, event: any) {
        const dropdownElement = document.querySelector('.filter-dropdown-container') as HTMLElement;
        if (dropdownElement) {
            const iconElement = event.target;
            const rect = iconElement.getBoundingClientRect();

            // Position dropdown below the header
            dropdownElement.style.top = (rect.bottom + 5) + 'px';
            dropdownElement.style.left = Math.max(10, rect.left - 100) + 'px';
        }
    }

    hideDropdownDelayed(filterType: string) {
        this.hideDropdownTimeout = setTimeout(() => {
            this.showDropdown[filterType] = false;
        }, 150);
    }

    setupCurrentFilterData(filterType: string) {
        // Set current filter search
        this.currentFilterSearch = this.columnFilters[filterType + 'Search'] || '';

        // Set current select all state
        this.currentSelectAllState = this.columnFilters[filterType + 'SelectAll'];

        // Set current filtered options
        this.currentFilteredOptions = this.filteredOptions[filterType] || [];

        // Set current selected options
        this.currentSelectedOptions = this.columnFilters[filterType + 'Selected'] || {};
    }

    getCurrentColumnProp(): string {
        return this.getColumnProp(this.currentActiveFilter);
    }

    // Close all dropdowns when clicking outside
    closeAllDropdowns() {
        Object.keys(this.showDropdown).forEach(key => {
            this.showDropdown[key] = false;
        });
        this.currentActiveFilter = '';
    }

    // Add property to store filtered data
    filteredDataArray = [];

    // Enhanced table styling for phoneTrackingReport with inline column filters
    // Uses existing applyFilter() method from base component functionality

}




// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/reports/reports.component.ts